angular.module('impactx.basket').controller('BasketCtrl', [
    '$scope',
    'dataGen',
    '$context',
    '$location',
    '$mdToast',
    '$mdDialog',
    '$routeParams',
    '$filter',
    'basketTemplateMenu',
    '$securityManager',
    '$redirect',
    'ToastService',
    'WarningService',
    'AddToBasketService',
    'ProductSelectionService',
    'TranslationService',
    '$errorHandler',
    '$route',
    'OpenGovernmentDataService',
    '$q',
    'AppConfiguration',
    'BasketService',
    'ToolbarService',
    'MinWidthService',
    '$workspace',
    'FileHelperService',
    '$timeout',
    'NewWindowService',
    '$listCache',
    'LogoutTimerService',
    'LoadingDialogService',
    'ConfirmationService',
    'ixaSearchSignals',
    'ixaBasketActions',
    'PollingService',
    BasketCtrl]);

function BasketCtrl($scope, dataGen, $context, $location, $mdToast, $mdDialog, $routeParams, $filter, basketTemplateMenu, $securityManager, $redirect, ToastService,
                    WarningService, AddToBasketService, ProductSelectionService, TranslationService, $errorHandler, $route, OpenGovernmentDataService, $q, AppConfiguration,
                    BasketService, ToolbarService, MinWidthService, $workspace, FileHelperService, $timeout, NewWindowService, $listCache, LogoutTimerService,
                    LoadingDialogService, ConfirmationService, ixaSearchSignals, ixaBasketActions, PollingService) {

    MinWidthService.setSpecialMinWidthForDialog($scope, 1024);

    var deletionInProgress = false;
    $scope.isExternalGuest = {value: false};
    var externalGuestWatcher = $scope.$watch(function () {
        return $securityManager.hasProcessesSet()
    }, function (newVal) {
        if (newVal) {
            $scope.isExternalGuest.value = $securityManager.isProcessAllowed("OrderGuestBasket") && !$securityManager.isSuperUser();
            externalGuestWatcher();
        }
    });
    $scope.refreshBasketUserAndCompanyRelation = {value: false};
    $scope.useFFClassicDialog = AppConfiguration.get('useFFClassicDialog');
    $scope.useFFOfferDialog = AppConfiguration.get('useFFOfferDialog');

    $scope.addressesLayout = AppConfiguration.get('basketAddressesLayout');
    $scope.controlsLayout = AppConfiguration.get('basketControlsLayout');
    $scope.datesLayout = AppConfiguration.get('basketDatesLayout');

    $scope.orderRequestInProgress = false;
    $scope.orderRequestType = -1;

    var basketController = this;
    $scope.myDate = new Date();
    $scope.minDate = new Date(
        $scope.myDate.getFullYear(),
        $scope.myDate.getMonth(),
        $scope.myDate.getDate());

    $scope.selectedBasketItems = [];
    var lastSelectedItems = [];
    $scope.regExp = /[^0-9.,]+/g;
    $scope.iteratorIndex = 1;
    $scope.data = {};
    $scope.data.basket = {};
    $scope.data.basket.control = {};
    $scope.data.basket.control.ctu = {};
    $scope.data.basket.control.ctt = {};
    $scope.data.basket.control.prj = {};
    $scope.selectedBasketSupplier = [];
    var lastSelectedSupplierHeaders = [];
    $scope.showSupplierAddresses = {value: false};
    $scope.showSupplierControl = {value: false};
    $scope.showSupplierDate = {value: false};
    $scope.showSupplierShare = {value: false};
    $scope.showSupplierComments = {value: false};
    $scope.showItemControl = {value: false};
    $scope.showItemAddresses = {value: false};
    $scope.showItemComments = {value: false};
    $scope.numberOfItems = {value: 0};
    $scope.basketHasChanged = false;
    $scope.ctrlRequired = {};
    $scope.errorListForSend = [];
    $scope.errorListProcess = [];
    $scope.errorListSendAndProcess = [];
    $scope.errorListForDirty = [];
    $scope.sendDemandIgnoreFields = [];

    $scope.hasControlLabels = {};
    $scope.supplierControlLabels = [];
    $scope.noDeliveryAddressAvailableWarningShown = false;

    var uniteOptimizationPollDelay;
    this.startUniteOptimizationWatch = function () {
        if (!$context.wasInitialized || $context.hasUniteItems) {
            uniteOptimizationPollDelay = $timeout(function () {
                PollingService.start('uniteOptimization', '/basket/unitestatus', function (data) {
                    $context.uniteOptimizationRunning = !!impactX.isDefined(data, 'data.running');
                }, 1000);
            }, 1500);
        }
    };
    this.stopUniteOptimizationWatch = function () {
        $timeout.cancel(uniteOptimizationPollDelay);
        PollingService.stop('uniteOptimization');
        $context.uniteOptimizationRunning = false;
    };

    basketController.approvalUsers = undefined;
    $scope.getBasket = function (callUniteUpdate) {
        basketController.startUniteOptimizationWatch();
        return dataGen.getData($scope, {id: $routeParams.id, callUniteUpdate: !!callUniteUpdate}, "/basket/view").then(function () {
            if (impactX.isDefined($scope, 'data.basket.approval') &&
                !impactX.isDefined($scope, 'data.basket.isTemplate') &&
                !impactX.isDefined($scope, 'data.isExternalGuest.value') &&
                !impactX.isDefined($scope, 'data.basket.isDispositionTemplate') &&
                impactX.isDefined($scope, 'data.basket.approval.isManualApproval')) {
                dataGen.getData({}, {id: $routeParams.id}, "/basket/approvalusers", null, true).then(function (data) {
                    basketController.approvalUsers = data.data.entries;
                });
            }
            else {
                basketController.approvalUsers = [];
            }

            $scope.handleData();
            if ($scope.data.basket.refreshBasketCount) {
                $context.refreshBasket({}, dataGen, $context);
            }

            if ($scope.data.basket.control) {
                for (var key in $scope.data.basket.control) {
                    $scope.ctrlRequired[key] = $scope.data.basket.control[key].showMust;
                }
                $scope.initControlWatch();
            }
            $scope.initCompanyWatch();
            angular.forEach($scope.data.basket.basketSupplierHeaderList, function(bks){
                if (bks.ogd) {
                    BasketService.validateOGD(bks, false).then(function()
                    {
                        if(bks.ogd.isDirty)
                        {
                            $scope.errorListForDirty.push($scope.trns.position + " " +  bks.contractName +" (" + bks.contractNo +"): "+ $scope.trns.errorDirty);
                        }
                    });
                }
                BasketService.validateSPO(bks, false);
            });

            if (impactX.isDefined($scope, "data.basket.noDeliveryAddressAvailableWarning") && !$scope.noDeliveryAddressAvailableWarningShown) {
                $errorHandler.showWarnings([{warning: $scope.data.basket.noDeliveryAddressAvailableWarning}]);
                $scope.noDeliveryAddressAvailableWarningShown = true;
            }
        }).finally(function () {
            basketController.stopUniteOptimizationWatch();
        });
    };
    $scope.getBasket(true);

    this.removeAvailableLists = function (basket) {
        if (basket) {
            for (var i = 0; i < basket.basketSupplierHeaderList.length; i++) {
                var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
                basketController.removeControlAvailableListsOnObject(basketSupplier);
                for (var j = 0; j < basketSupplier.basketItemList.length; j++) {
                    basketController.removeAvailableListsOnObject(basketSupplier.basketItemList[j]);
                }
            }
        }
    };

    this.addAllAvailableLists = function (basket) {
        if (basket) {
            for (var i = 0; i < basket.basketSupplierHeaderList.length; i++) {
                var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
                basketController.copyControlStructureReference(basketSupplier.control, basketSupplier.ctrlRef);
                for (var j = 0; j < basketSupplier.basketItemList.length; j++) {
                    var basketItem = basketSupplier.basketItemList[j];
                    basketController.copyControlStructureReference(basketItem.control, basketSupplier.ctrlRef);
                    basketController.copyAddressReference(basketItem, basketSupplier);
                }
            }
        }
    };

    this.removeAvailableListsOnObject = function (object) {
        if (object.deliveryAddresses) {
            object.deliveryAddresses.entries = [];
        }
        if (object.invoiceAddresses) {
            object.invoiceAddresses.entries = [];
        }
        if (object.contactAddresses) {
            object.contactAddresses.entries = [];
        }
        if (object.handOverAddresses) {
            object.handOverAddresses.entries = [];
        }
        basketController.removeControlAvailableListsOnObject(object);
    };

    this.removeControlAvailableListsOnObject = function (object) {
        var control = object.control;
        if (control) {
            if (control.ctu) {
                control.ctu.allowed = {};
            }
            if (control.prj) {
                control.prj.allowed = {};
            }
            if (control.ctt) {
                control.ctt.allowed = {};
            }
            if (control.ctrlA) {
                control.ctrlA.allowed = {};
            }
            if (control.ctrlB) {
                control.ctrlB.allowed = {};
            }
            if (control.ctrlC) {
                control.ctrlC.allowed = {};
            }
            if (control.ctrlD) {
                control.ctrlD.allowed = {};
            }
            if (control.crd) {
                control.crd.allowed = {};
            }
            if (control.psp) {
                control.psp.allowed = {};
            }
            if (control.act) {
                control.act.allowed = {};
            }
            if (control.net) {
                control.net.allowed = {};
            }
            if (control.asn) {
                control.asn.allowed = {};
            }
            if (control.ino && !control.ino.forceOwnAllowed) { // currently only INO can have this set to true
                control.ino.allowed = {};
            }
            if (control.loc) {
                control.loc.allowed = {};
            }
            if (control.eko) {
                control.eko.allowed = {};
            }
            if (control.ekg) {
                control.ekg.allowed = {};
            }
        }
    };

    this.copyAddressReference = function (targetObject, sourceObject) {
        if (sourceObject.deliveryAddresses && targetObject.deliveryAddresses) {
            targetObject.deliveryAddresses.entries = sourceObject.deliveryAddresses.entries;
        }
        if (sourceObject.invoiceAddresses && targetObject.invoiceAddresses) {
            targetObject.invoiceAddresses.entries = sourceObject.invoiceAddresses.entries;
        }
        if (sourceObject.contactAddresses && targetObject.contactAddresses) {
            targetObject.contactAddresses.entries = sourceObject.contactAddresses.entries;
        }
        if (sourceObject.handOverAddresses && targetObject.handOverAddresses) {
            targetObject.handOverAddresses.entries = sourceObject.handOverAddresses.entries;
        }
    };

    this.copyControlStructureReference = function (targetControl, sourceControl) {
        if (targetControl && sourceControl) {
            if (targetControl.ctu  && !targetControl.ctu.forceOwnAllowed) {
                targetControl.ctu.allowed = JSON.parse(JSON.stringify(sourceControl.ctu.allowed));
            }
            if (targetControl.prj  && !targetControl.prj.forceOwnAllowed) {
                targetControl.prj.allowed = JSON.parse(JSON.stringify(sourceControl.prj.allowed));
            }
            if (targetControl.ctt && !targetControl.ctt.forceOwnAllowed) {
                targetControl.ctt.allowed = JSON.parse(JSON.stringify(sourceControl.ctt.allowed));
            }
            if (targetControl.ctrlA  && !targetControl.ctrlA.forceOwnAllowed) {
                targetControl.ctrlA.allowed = JSON.parse(JSON.stringify(sourceControl.ctrlA.allowed));
            }
            if (targetControl.ctrlB  && !targetControl.ctrlB.forceOwnAllowed) {
                targetControl.ctrlB.allowed = JSON.parse(JSON.stringify(sourceControl.ctrlB.allowed));
            }
            if (targetControl.ctrlC  && !targetControl.ctrlC.forceOwnAllowed) {
                targetControl.ctrlC.allowed = JSON.parse(JSON.stringify(sourceControl.ctrlC.allowed));
            }
            if (targetControl.ctrlD  && !targetControl.ctrlD.forceOwnAllowed) {
                targetControl.ctrlD.allowed = JSON.parse(JSON.stringify(sourceControl.ctrlD.allowed));
            }
            if (targetControl.crd  && !targetControl.crd.forceOwnAllowed) {
                targetControl.crd.allowed = JSON.parse(JSON.stringify(sourceControl.crd.allowed));
            }
            if (targetControl.psp  && !targetControl.psp.forceOwnAllowed) {
                targetControl.psp.allowed = JSON.parse(JSON.stringify(sourceControl.psp.allowed));
            }
            if (targetControl.act  && !targetControl.act.forceOwnAllowed) {
                targetControl.act.allowed = JSON.parse(JSON.stringify(sourceControl.act.allowed));
            }
            if (targetControl.net  && !targetControl.net.forceOwnAllowed) {
                targetControl.net.allowed = JSON.parse(JSON.stringify(sourceControl.net.allowed));
            }
            if (targetControl.asn  && !targetControl.asn.forceOwnAllowed) {
                targetControl.asn.allowed = JSON.parse(JSON.stringify(sourceControl.asn.allowed));
            }
            if (targetControl.ino && !targetControl.ino.forceOwnAllowed) { // currently only INO can have this set to true
                targetControl.ino.allowed = JSON.parse(JSON.stringify(sourceControl.ino.allowed));
            }
            if (targetControl.loc  && !targetControl.loc.forceOwnAllowed) {
                targetControl.loc.allowed = JSON.parse(JSON.stringify(sourceControl.loc.allowed));
            }
            if (targetControl.eko  && !targetControl.eko.forceOwnAllowed) {
                targetControl.eko.allowed = JSON.parse(JSON.stringify(sourceControl.eko.allowed));
            }
            if (targetControl.ekg  && !targetControl.ekg.forceOwnAllowed) {
                targetControl.ekg.allowed = JSON.parse(JSON.stringify(sourceControl.ekg.allowed));
            }
        }
    };

    this.refreshCompanyTemplateData = function (updateExisting) {
        if ($scope.data.basket.isOwnCompanyTemplate) {
            $scope.refreshBasketUserAndCompanyRelation.value = true;
            if ($scope.data.basket.allRelatableObjects) {
                ToastService.openStandardToast($scope.trns.loadingComAndUser);
            }
            var params = {
                id: $scope.data.basket.id,
                allObjects: $scope.data.basket.allRelatableObjects,
                assignedUsers: updateExisting ? $scope.data.basket.templateUserRelation : null,
                assignedCompanies: updateExisting ? $scope.data.basket.templateCompanyRelation : null
            };
            dataGen.getData({}, params, "/basket/companytemplate", null, !$scope.data.basket.allRelatableObjects).then(function (data) {
                $scope.refreshBasketUserAndCompanyRelation.value = false;
                $scope.data.basket.templateCompanyRelation = data.data.templateCompanyRelation;
                $scope.data.basket.templateUserRelation = data.data.templateUserRelation;
            });
        }
    };

    this.copyAccountingToItems = function () {
        var dataObject = {
            basket: $scope.data.basket
        };
        dataGen.postAsForm({}, dataObject, '/basket/copyaccountingtoitems').then(function (data) {
            if (data.errors.length === 0 && data.data) {
                $scope.data = data.data;
                $context.refreshBasket({}, dataGen, $context);
                $scope.getBasket();
                ToastService.openStandardToast($scope.trns.copyAccountingToItemsSuccessfully);
            }
        });
    };

    $scope.refreshCompanyTemplateData = function () {
        basketController.refreshCompanyTemplateData(true);
    };

    this.canEdit = function () {
        return !impactX.isDefined($scope, "data.basket.noEdit") && $scope.data.basket && !$scope.data.basket.isDispositionAnswer;
    };

    this.canEditSupplier = function () {
        return !impactX.isDefined($scope, "data.basket.noEdit") && $scope.data.basket;
    };

    this.allowsTheSelectedProcessRequest = function () {
        return !impactX.isDefined($scope, "data.basket.pid.selected") || $scope.data.basket.pid.selected.isAllowedForPRH;
    };

    this.allowsTheSelectedProcessDemands = function () {
        return !impactX.isDefined($scope, "data.basket.pid.selected") || $scope.data.basket.pid.selected.isAllowedForDEH;
    };

    this.canSave = function () {
        return !impactX.isDefined($scope, "data.basket.noEdit");
    };

    this.hasItemsSelected = function () {
        return $scope.selectedBasketItems.length > 0;
    };

    this.hasOneItemSelected = function () {
        return $scope.selectedBasketItems.length == 1;
    };

    this.isOCIItem = function () {
        return $scope.selectedBasketItems.length && $scope.selectedBasketItems.length === 1 && $scope.selectedBasketItems[0].isOCI;
    };

    this.supportsValidateOCI = function () {
        return basketController.isOCIItem() && $scope.selectedBasketItems[0].supportsOCIValidate;
    };

    this.supportsDetailOCI = function () {
        return basketController.isOCIItem() && $scope.selectedBasketItems[0].supportsOCIDetail;
    };

    this.hasSupplierSelected = function () {
        return $scope.selectedBasketSupplier.length > 0;
    };

    this.isItemValid = function () {
        return $scope.selectedBasketItems.length == 1 && !$scope.selectedBasketItems[0].isInvalid;
    };

    this.isTemplate = function () {
        return impactX.isDefined($scope, "data.basket.isTemplate");
    };

    this.canEditSupplierAndHasSupplierSelected = function () {
        return basketController.hasSupplierSelected() && basketController.canEdit() && !basketController.isTemplate() &&
            !$scope.data.basket.isDispositionTemplate;
    };

    this.canEditSupplierShareAndHasSupplierSelected = function () {
        return basketController.canEditSupplierAndHasSupplierSelected() && !$scope.data.basket.isDemandBaske &&
            AppConfiguration.get("useShareOrderStatus");
    };

    this.canEditItemAddress = function () {
        return !basketController.useBasketAddressDialog() && basketController.canEditItemOrderData() && !$scope.data.basket.minimized;
    };

    this.canEditSupplierHeaderAddress = function () {
        return !basketController.useBasketAddressDialog() && basketController.canEditSupplierAndHasSupplierSelected();
    };

    this.canEditSupplierHeaderControls = function () {
        return basketController.canEditSupplierAndHasSupplierSelected()
            && !basketController.useBasketControlAlternative()
            && !basketController.useBasketControlDialog()
            && $scope.selectedBasketSupplier.length === 1
            && !basketController.hasReadOnlyHeaderControls($scope.selectedBasketSupplier[0].aat, $scope.selectedBasketSupplier[0].control);
    };

    this.canEditAndHasItemsSelected = function () {
        return basketController.hasItemsSelected() && basketController.canEdit() && !$scope.data.basket.isDispositionAnswer && basketController.isItemValid();
    };

    this.canEditCommentsAndHasItemsSelected = function () {
        return basketController.canEditAndHasItemsSelected() && !$scope.data.basket.minimized;
    };

    this.canEditItemOrderData = function () {
        return basketController.canEditAndHasItemsSelected() && !$scope.data.basket.isDispositionTemplate && basketController.isItemValid();
    };

    this.canEditCommentsAndItemOrderData = function () {
        return basketController.canEditItemOrderData() && !$scope.data.basket.minimized;
    };

    this.canEditItemControls = function () {
        return !basketController.useBasketControlAlternative()
            && !basketController.useBasketControlDialog()
            && basketController.canEditItemOrderData() && !basketController.isTemplate()
            && !basketController.hasReadOnlyHeaderControls($scope.selectedBasketItems[0].aat, $scope.selectedBasketItems[0].control)
            && !$scope.data.basket.minimized;
    };

    this.canDeleteItems = function () {
        if (basketController.hasItemsSelected() && basketController.canEdit()) {
            var selectGroupsOfMainItems = [];
            var selectGroupsOfReferenceItems = [];
            for (var i = 0; i < $scope.selectedBasketItems.length; i++) {
                var basketItem = $scope.selectedBasketItems[i];
                if (basketItem.nonDeletable) {
                    return false;
                }
                if (basketItem.isBundleItem && basketItem.isSelectReferenceMain && selectGroupsOfMainItems.indexOf(basketItem.selectGroup) < 0) {
                    selectGroupsOfMainItems.push(basketItem.selectGroup);
                }
                else if (basketItem.isBundleItem && basketItem.selectGroup > 0 && selectGroupsOfReferenceItems.indexOf(basketItem.selectGroup) < 0) {
                    selectGroupsOfReferenceItems.push(basketItem.selectGroup);
                }
            }
            if (selectGroupsOfReferenceItems.length > selectGroupsOfMainItems.length) {
                return false;
            }
            else {
                for (var i = 0; i < selectGroupsOfReferenceItems.length; i++) {
                    if (selectGroupsOfMainItems.indexOf(selectGroupsOfReferenceItems[i]) < 0) {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    };

    this.canEditReferences = function () {
        if (basketController.hasItemsSelected() && basketController.canEdit()) {
            var setSelectGroup = 0;
            for (var i = 0; i < $scope.selectedBasketItems.length; i++) {
                var basketItem = $scope.selectedBasketItems[i];
                if (!basketItem.selectGroup || basketItem.selectGroup <= 0 || (setSelectGroup > 0 && basketItem.selectGroup !== setSelectGroup)) {
                    return false;
                }
                setSelectGroup = basketItem.selectGroup;
            }
            return true;
        }
        return false;
    };

    this.getSelectedItemsLabel = function () {
        return $scope.selectedBasketItems.length + ' ' + $scope.trns.selected;
    };

    this.canShowEditDialog = function () {
        return $scope.selectedBasketItems.length > 0 && $scope.selectedBasketItems.length == 1
            && !$scope.selectedBasketItems[0].isInvalid && !$scope.selectedBasketItems[0].readOnly && basketController.canEdit() &&
            (!$scope.isExternalGuest.value || $scope.selectedBasketItems[0].isFreeform)
            && !$scope.data.basket.isDispositionAnswer;
    };

    this.canShowGreetingCardDialog = function () {
        return basketController.canShowEditDialog() && $scope.selectedBasketItems[0].greetingCardAvailable;
    };
    
    this.canShowVisitingCardButton = function () {
        return basketController.canShowEditDialog() && $scope.selectedBasketItems[0].isVisitingCard;
    };

    this.canShowVerificationDialog = function () {
        return basketController.canShowEditDialog() && $scope.selectedBasketItems[0].verificationTraceAvailable;
    };

    this.canShowCateringDialog = function () {
        return basketController.canShowEditDialog() && $scope.selectedBasketItems[0].isCatering;
    };

    this.hasNothingSelected = function () {
        return !basketController.hasItemsSelected() && !basketController.hasSupplierSelected();
    };

    this.canActivate = function () {
        return basketController.hasNothingSelected() && !impactX.isDefined($scope, "data.basket.isActive") && basketController.canEdit();
    };

    this.canDeactivate = function () {
        return basketController.hasNothingSelected() && basketController.isTemplate() && $scope.data.basket.isActive && basketController.canEdit();
    };

    this.toggleMinimized = function () {
        $scope.data.basket.minimized = !$scope.data.basket.minimized;
    };

    this.isMinimized = function () {
        return !!$scope.data.basket.minimized;
    };

    this.isNotMinimized = function () {
        return !$scope.data.basket.minimized;
    };

    this.canEditHeaderData = function () {
        return basketController.hasNothingSelected() && !basketController.isTemplate() && basketController.canEdit() && !$scope.data.basket.isDispositionTemplate;
    };

    this.canEditHeaderShare = function () {
        return basketController.canEditHeaderData() && !$scope.data.basket.isDemandBasket && AppConfiguration.get("useShareOrderStatus");
    };

    this.canEditHeaderControlData = function () {
        return !basketController.useBasketControlAlternative() && !basketController.useBasketControlDialog()
            && basketController.canEditHeaderData() && impactX.isDefined($scope, "data.basket.control")
            && !$scope.data.basket.showBasketHeaderAccounts
            && !basketController.hasReadOnlyHeaderControls($scope.data.basket.aat, $scope.data.basket.control);
    };

    this.canOpenHeaderControlDialog = function () {
        return basketController.useBasketControlDialog()
            && basketController.canEditHeaderData() && impactX.isDefined($scope, "data.basket.control")
            && !basketController.hasReadOnlyHeaderControls($scope.data.basket.aat, $scope.data.basket.control);
    };

    this.canOpenSupplierControlDialog = function () {
        return basketController.useBasketControlDialog() && basketController.canEditSupplierAndHasSupplierSelected()
            && $scope.selectedBasketSupplier.length === 1
            && !basketController.hasReadOnlyHeaderControls($scope.selectedBasketSupplier[0].aat, $scope.selectedBasketSupplier[0].control);
    };

    this.canOpenItemControlDialog = function () {
        return (basketController.useBasketControlDialog() || $scope.data.basket.minimized)
            && basketController.hasOneItemSelected()
            && basketController.canEditItemOrderData()
            && !basketController.hasReadOnlyHeaderControls($scope.selectedBasketItems[0].aat, $scope.selectedBasketItems[0].control);
    };

    this.canOpenHeaderAddressDialog = function () {
        return basketController.useBasketAddressDialog() && basketController.canEditHeaderData();
    };

    this.canOpenSupplierHeaderAddressDialog = function () {
        return basketController.useBasketAddressDialog() && basketController.canEditSupplierAndHasSupplierSelected();
    };

    this.canOpenItemAddressDialog = function () {
        return (basketController.useBasketAddressDialog() || $scope.data.basket.minimized)
            && basketController.hasOneItemSelected()
            && basketController.canEditItemOrderData();
    };

    this.useBasketControlAlternative = function () {
        return $scope.controlsLayout === 2;
    };

    this.useBasketControlDialog = function () {
        return $scope.controlsLayout === 1;
    };

    this.useBasketAddressDialog = function () {
        return $scope.addressesLayout === 1;
    };

    this.useBasketDatesDialog = function () {
        return $scope.datesLayout === 1;
    };

    this.canAddFreeForm = function () {
        return $scope.useFFClassicDialog && basketController.hasNothingSelected() && basketController.canEdit() && impactX.isDefined($scope, "data.basket.isFreeFormAllowed");
    };

    this.canAddFreeFormOffer = function () {
        return $scope.useFFOfferDialog && basketController.hasNothingSelected() && basketController.canEdit() && impactX.isDefined($scope, "data.basket.isFreeFormAllowed");
    };

    this.canToggleTemplate = function () {
        return basketController.hasNothingSelected() && basketController.canEdit()
            && impactX.isDefined($scope, "data.basket.isDispositionTemplateOriginal")
            && impactX.isDefined($scope, "data.basket.schedulerFrequency.frequencyType.selected.id") === 20;
    };

    this.canDeactivateTemplate = function () {
        return basketController.canToggleTemplate() && $scope.data.basket.templatePending;
    };

    this.canActivateTemplate = function () {
        return basketController.canToggleTemplate() && !$scope.data.basket.templatePending;
    };

    this.canAddToCurrentBasket = function () {
        return basketController.hasNothingSelected() && impactX.isDefined($scope, "data.basket.canAddToCurrentBasket")
            && !$scope.data.basket.isDispositionAnswer;
    };

    this.canDeleteBasket = function () {
        if (impactX.isDefined($scope, "data.basket")) {
            return basketController.hasNothingSelected() && $scope.data.basket.id > 0 && !impactX.isDefined($scope, "data.basket.noEdit");
        }
    };

    this.canSaveBasketAsTemplate = function () {
        return $scope.numberOfItems.value > 0 && basketController.hasNothingSelected()
            && basketController.canEdit() && impactX.isDefined($scope, "data.basket.canSaveAsTemplate");
    };

    this.canAddItemsToCurrentBasket = function () {
        return basketController.hasItemsSelected() && impactX.isDefined($scope, "data.basket.canAddToCurrentBasket")
            && !$scope.data.basket.isDispositionAnswer;
    };

    this.canReplaceItem = function () {
        return $scope.selectedBasketItems.length == 1 && basketController.canEdit()
            && !$scope.selectedBasketItems[0].infoGroup && !$scope.data.basket.isDispositionAnswer && !$scope.selectedBasketItems[0].selectGroup
            && !$scope.selectedBasketItems[0].basketMandatoryGroup && !$scope.selectedBasketItems[0].basketItemGroupId
            && !$scope.selectedBasketItems[0].isRFQIRelated && !$scope.selectedBasketItems[0].nonDeletable;
    };

    this.canDuplicateItem = function () {
        return $scope.selectedBasketItems.length === 1 && basketController.canEdit()
            && $scope.selectedBasketItems[0].isFreeform && !$scope.selectedBasketItems[0].isBundleItem
            && !$scope.selectedBasketItems[0].basketItemGroupId
            && !$scope.selectedBasketItems[0].isRFQIRelated;
    };

    this.canEnterCode = function () {
        return impactX.isDefined($scope, "data.basket.showCodeButton")
    };

    this.canCopyAccountingToItems = function () {
        return impactX.isDefined($scope, "data.basket.canCopyAccountingToItems");
    };

    this.supportsValidateSAP = function () {
        return impactX.isDefined($scope, "data.basket.showSAPBasketValidation");
    };

    function hasDates(datesHolder) {
        return datesHolder.deliveryDate || datesHolder.firstDeliveryDate || datesHolder.lastDeliveryDate
    }

    this.canToggleHeaderDates = function () {
        return basketController.canEditHeaderData() &&
            !basketController.useBasketDatesDialog() &&
            hasDates($scope.data.basket) &&
            !$scope.data.basket.supplierRequestedDeliveryDatesAvailable;
    };

    this.canToggleSupplierDates = function () {
        var result = basketController.canEditSupplierAndHasSupplierSelected() &&
            !basketController.useBasketDatesDialog();
        if (result) {
            angular.forEach($scope.selectedBasketSupplier, function (bks) {
                result = result && hasDates(bks);
            });
        }
        return result;
    };

    this.canOpenHeaderDatesDialog = function () {
        return basketController.canEditHeaderData() &&
            basketController.useBasketDatesDialog() &&
            hasDates($scope.data.basket) &&
            !$scope.data.basket.supplierRequestedDeliveryDatesAvailable;
    };

    this.canOpenSupplierDatesDialog = function () {
        var result = basketController.canEditSupplierAndHasSupplierSelected() &&
            basketController.useBasketDatesDialog();
        if (result) {
            angular.forEach($scope.selectedBasketSupplier, function (bks) {
                result = result && hasDates(bks);
            });
        }
        return result;
    };

    this.canOpenItemDatesDialog = function () {
        return basketController.canEditItemOrderData() && hasDates($scope.selectedBasketItems[0])
            && !$scope.selectedBasketItems[0].supplierRequestedDeliveryDatesAvailable
            && !($scope.selectedBasketItems[0].allowDistributionList && $scope.data.basket.sendDistributionList && $scope.data.basket.sendDistributionList.value);
    };

    this.itemsAreValid = function(items) {
        for(var i = 0; i < items.length; i++) {
            if(items[i].isInvalid) {
                return false;
            }
        }
        return true;
    };

    this.canBulkChangeItemData = function () {
        return $scope.selectedBasketItems.length > 1 && basketController.canEdit() && !$scope.data.basket.isDispositionAnswer && basketController.itemsAreValid($scope.selectedBasketItems);
    };

    this.editReferences = function (event) {
        var saveSuccess = $scope.trns.referencesUpdated;
        $mdDialog.show({
            controller: "SelectReferenceDialogCtrl",
            controllerAs: "selectReferenceDialogCtrl",
            templateUrl: 'shared/basketlink/templates/selectreference.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                proId: 0,
                bkiId: $scope.selectedBasketItems[0].id,
                canDecideLater: false
            }
        }).then(function () {
            $scope.deleteBasketItemSelection();
            $scope.getBasket();
            ToastService.openStandardToast(saveSuccess);
        });
    };

    this.showCodeInput = function (event) {
        $mdDialog.show({
            controller: "EnterOffercodeCtrl",
            controllerAs: "enterOffercodeCtrl",
            templateUrl: "modules/basket/templates/enteroffercode.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                trns: $scope.trns
            }
        }).then(function () {
            $route.reload();
        });
    };

    this.uploadScannerFile = function () {
        angular.element('#uploadScanner').on('change', basketController.handleFileSelect);
        $timeout(function () {
            angular.element('#uploadScanner').click();
        })
    };

    this.handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        if (!FileHelperService.checkAllowedFileWithError(file.name)) {
            return;
        }
        $(this).val("");

        if (file) {
            $scope.saveBasketBackground(true).then(function () {
                var data = {
                    file: file,
                    bkhId: $scope.data.basket.id
                };

                dataGen.uploadFile(data, '/basket/scanner/import', true, true).then(function () {
                    $scope.getBasket();
                    ToastService.openStandardToast($scope.trns.scannerImportSuccess);
                }, function () {
                    $scope.getBasket();
                });
            });
        }
    };

    this.canUseScannerImport = function () {
        return basketController.hasNothingSelected() && basketController.canEdit() && impactX.isDefined($scope, "data.basket.canUseScannerImport");
    };

    this.showBulkDialogAddress = function () {
        $scope.saveBasketBackground(true).then(function () {
            BasketService.openBulkChangeDialog($scope.selectedBasketItems, $scope.data.basket.id, 'address').then(function () {
                $scope.deleteBasketItemSelection();
                $scope.getBasket();
            })
        });
    };

    this.showBulkDialogDate = function () {
        $scope.saveBasketBackground(true).then(function () {
            BasketService.openBulkChangeDialog($scope.selectedBasketItems, $scope.data.basket.id, 'date').then(function () {
                $scope.deleteBasketItemSelection();
                $scope.getBasket();
            })
        });
    };

    this.showBulkDialogControl = function () {
        $scope.saveBasketBackground(true).then(function () {
            BasketService.openBulkChangeDialog($scope.selectedBasketItems, $scope.data.basket.id, 'control').then(function () {
                $scope.deleteBasketItemSelection();
                $scope.getBasket();
            })
        });
    };

    $scope.initCompanyWatch = function () {
        if (impactX.isDefined($scope, 'data.basket.allowedBuyerCompanies')) {
            $scope.$watch(function () {
                return impactX.isDefined($scope, 'data.basket.allowedBuyerCompanies.selected')
            }, function (newVal) {
                if (newVal) {
                    basketController.changeBuyerCompanyWithBasket(newVal.id);
                }
            });
            if ($scope.data.basket.allowedBuyerCompanies.selected) {
                $scope.selectedComId = $scope.data.basket.allowedBuyerCompanies.selected.id;
            }
        }
    }

    this.canForwardBasket = function () {
        return basketController.hasNothingSelected() && !basketController.isTemplate() && $scope && $scope.data && $scope.data.basket && $scope.data.basket.canForwardBasket && basketController.canEdit();
    };

    this.showForwardBasketDialog = function () {
        $scope.saveBasketBackground(true).then(function () {
            BasketService.openForwardDialog($scope.data.basket.id).then(function () {
                $scope.noSave = true;
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null, $workspace.containsView("templateandbasketlist") ? "/templateandbasketlist" : "/basketlist");
                ToastService.openStandardToast($scope.trns.forwardBasketSuccessfully);
            })
        });
    };

    this.canImportBulkOrder = function () {
        return $scope.data.basket.canImportBulkOrders;
    }

    this.importBulkOrder = function () {
        ixaBasketActions.openBulkOrderImportDialog();
    }

    $scope.handleData = function () {
        $scope.errorListForSend.length = 0;
        if ($scope.data.basket.isCompanyTemplate || $scope.data.basket.isUserTemplate) {
            basketTemplateMenu.refreshAllTemplates();
        }
        if ($scope.isExternalGuest.value) {
            $scope.buttonDefinition = [
                {
                    icon: 'mdi-arrow-collapse-vertical',
                    iconClass: 'basket-minimize-button',
                    tooltip: $scope.trns.minimize,
                    type: 'icon',
                    action: basketController.toggleMinimized,
                    condition: basketController.isNotMinimized
                },
                {
                    icon: 'mdi-arrow-expand-vertical',
                    iconClass: 'basket-expand-button',
                    tooltip: $scope.trns.expand,
                    type: 'icon',
                    action: basketController.toggleMinimized,
                    condition: basketController.isMinimized
                },
                {
                    label: $scope.trns.save,
                    action: $scope.saveBasket,
                    type: 'dialogaction',
                    condition: basketController.canEdit
                },
                {
                    labelFunction: basketController.getSelectedItemsLabel,
                    action: $scope.deleteBasketItemSelection,
                    type: 'dialogaction',
                    condition: basketController.canEditAndHasItemsSelected
                },
                {
                    label: $scope.trns.comments,
                    action: basketController.toggleItemComments,
                    type: 'dialogaction',
                    condition: basketController.canEditCommentsAndHasItemsSelected
                },
                {
                    label: $scope.trns.remove,
                    action: $scope.deleteItems,
                    type: 'dialogaction',
                    condition: basketController.canDeleteItems
                },
                {
                    label: $scope.trns.edit,
                    action: $scope.showBasketItemDialog,
                    type: 'dialogaction',
                    condition: basketController.canShowEditDialog
                },
                {
                    label: $scope.trns.addFreeForm,
                    action: $scope.showBasketItemDialog,
                    type: 'dialogaction',
                    condition: basketController.canAddFreeForm
                },
                {
                    label: $scope.trns.greetingCard,
                    action: $scope.showGreetingCardDialog,
                    type: 'dialogaction',
                    condition: basketController.canShowGreetingCardDialog
                },
                {
                    label: $scope.trns.visitingCard,
                    action: $scope.printVisitingCard,
                    type: 'dialogaction',
                    condition: basketController.canShowVisitingCardButton
                },
                {
                    label: $scope.trns.verificationDialog,
                    action: $scope.showVerificationDialog,
                    type: 'dialogaction',
                    condition: basketController.canShowVerificationDialog
                },
                {
                    label: $scope.trns.addFreeFormOffer,
                    action: basketController.showBasketItemOfferDialog,
                    type: 'dialogaction',
                    condition: basketController.canAddFreeFormOffer
                },
                {
                    label: $scope.trns.delete,
                    action: $scope.deleteBasket,
                    type: 'dialogaction',
                    condition: basketController.canDeleteBasket
                },
                {
                    label: $scope.trns.changeReferences,
                    action: basketController.editReferences,
                    type: 'dialogaction',
                    condition: basketController.canEditReferences
                },
                {
                    label: $scope.trns.enterCode,
                    action: basketController.showCodeInput,
                    type: 'dialogaction',
                    condition: basketController.canEnterCode
                },
                {
                    label: $scope.trns.print,
                    type: 'print',
                    condition: basketController.hasNothingSelected,
                    params: {
                        printToken: $scope.printTokens.header,
                    }
                }
            ];
        }
        else {
            $scope.buttonDefinition = [
                {
                    icon: 'mdi-arrow-collapse-vertical',
                    iconClass: 'icon-button-margin-adjust',
                    tooltip: $scope.trns.minimize,
                    type: 'icon',
                    action: basketController.toggleMinimized,
                    condition: basketController.isNotMinimized
                },
                {
                    icon: 'mdi-arrow-expand-vertical',
                    iconClass: 'icon-button-margin-adjust',
                    tooltip: $scope.trns.expand,
                    type: 'icon',
                    action: basketController.toggleMinimized,
                    condition: basketController.isMinimized
                },
                {
                    label: $scope.trns.save,
                    action: $scope.saveBasket,
                    type: 'dialogaction',
                    condition: basketController.canSave
                },
                {
                    labelFunction: basketController.getSelectedItemsLabel,
                    action: $scope.deleteBasketItemSelection,
                    type: 'dialogaction',
                    condition: basketController.canEditAndHasItemsSelected
                },
                {
                    label: $scope.trns.comments,
                    action: basketController.toggleItemComments,
                    type: 'dialogaction',
                    condition: basketController.canEditCommentsAndItemOrderData
                },
                {
                    label: $scope.trns.remove,
                    action: $scope.deleteItems,
                    type: 'dialogaction',
                    condition: basketController.canDeleteItems
                },
                {
                    label: $scope.trns.addresses,
                    action: basketController.openHeaderAddressDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenHeaderAddressDialog
                },
                {
                    label: $scope.trns.addresses,
                    action: basketController.openSupplierHeaderAddressDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenSupplierHeaderAddressDialog
                },
                {
                    label: $scope.trns.addresses,
                    action: basketController.openItemAddressDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenItemAddressDialog
                },
                {
                    label: $scope.trns.addresses,
                    action: basketController.toggleItemAddress,
                    type: 'dialogaction',
                    condition: basketController.canEditItemAddress
                },
                {
                    label: $scope.trns.addresses,
                    action: basketController.toggleSupplierAddresses,
                    type: 'dialogaction',
                    condition: basketController.canEditSupplierHeaderAddress
                },
                {
                    label: $scope.trns.control,
                    action: basketController.toggleHeaderControl,
                    type: 'dialogaction',
                    condition: basketController.canEditHeaderControlData
                },
                {
                    label: $scope.trns.control,
                    action: basketController.toggleSupplierControl,
                    type: 'dialogaction',
                    condition: basketController.canEditSupplierHeaderControls
                },
                {
                    label: $scope.trns.control,
                    action: basketController.toggleItemControl,
                    type: 'dialogaction',
                    condition: basketController.canEditItemControls
                },
                {
                    label: $scope.trns.control,
                    action: basketController.openHeaderControlDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenHeaderControlDialog
                },
                {
                    label: $scope.trns.control,
                    action: basketController.openSupplierHeaderControlDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenSupplierControlDialog
                },
                {
                    label: $scope.trns.control,
                    action: basketController.openItemControlDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenItemControlDialog
                },
                {
                    label: $scope.trns.edit,
                    action: $scope.showBasketItemDialog,
                    type: 'dialogaction',
                    condition: basketController.canShowEditDialog
                },
                {
                    label: $scope.trns.editCatering,
                    action: $scope.showCateringDialog,
                    type: 'dialogaction',
                    condition: basketController.canShowCateringDialog
                },
                {
                    label: $scope.trns.greetingCard,
                    action: $scope.showGreetingCardDialog,
                    type: 'dialogaction',
                    condition: basketController.canShowGreetingCardDialog
                },
                {
                   label: $scope.trns.visitingCard,
                   action: $scope.printVisitingCard,
                   type: 'dialogaction',
                   condition: basketController.canShowVisitingCardButton
               },
                {
                    label: $scope.trns.verificationDialog,
                    action: $scope.showVerificationDialog,
                    type: 'dialogaction',
                    condition: basketController.canShowVerificationDialog
                },
                {
                    label: $scope.trns.comments,
                    action: basketController.toggleSupplierComments,
                    type: 'dialogaction',
                    condition: basketController.canEditSupplierAndHasSupplierSelected
                },
                {
                    label: $scope.trns.dates,
                    action: basketController.toggleSupplierDate,
                    type: 'dialogaction',
                    condition: basketController.canToggleSupplierDates
                },
                {
                    label: $scope.trns.dates,
                    action: basketController.openSupplierHeaderDatesDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenSupplierDatesDialog
                },
                {
                    label: $scope.trns.activate,
                    action: $scope.activateBasket,
                    type: 'dialogaction',
                    condition: basketController.canActivate
                },
                {
                    label: $scope.trns.deactivate,
                    action: basketController.deactivateBasket,
                    type: 'dialogaction',
                    condition: basketController.canDeactivate
                },
                {
                    label: $scope.trns.comments,
                    action: basketController.toggleHeaderComments,
                    type: 'dialogaction',
                    condition: basketController.canEditHeaderData
                },
                {
                    label: $scope.trns.dates,
                    action: basketController.toggleHeaderDates,
                    type: 'dialogaction',
                    condition: basketController.canToggleHeaderDates
                },
                {
                    label: $scope.trns.dates,
                    action: basketController.openHeaderDatesDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenHeaderDatesDialog
                },
                {
                    label: $scope.trns.dates,
                    action: basketController.openItemDatesDialog,
                    type: 'dialogaction',
                    condition: basketController.canOpenItemDatesDialog
                },
                {
                    label: $scope.trns.notes,
                    action: basketController.toggleHeaderReferenceNos,
                    type: 'dialogaction',
                    condition: basketController.canEditHeaderData,
                    process: 'EditBasketReferenceNos'
                },
                {
                    label: $scope.trns.addFreeForm,
                    action: $scope.showBasketItemDialog,
                    type: 'dialogaction',
                    condition: basketController.canAddFreeForm
                },
                {
                    label: $scope.trns.addFreeFormOffer,
                    action: basketController.showBasketItemOfferDialog,
                    type: 'dialogaction',
                    condition: basketController.canAddFreeFormOffer
                },
                {
                    label: $scope.trns.deactivateTemplate,
                    action: $scope.toggleTemplate,
                    type: 'dialogaction',
                    condition: basketController.canDeactivateTemplate
                },
                {
                    label: $scope.trns.activateTemplate,
                    action: $scope.toggleTemplate,
                    type: 'dialogaction',
                    condition: basketController.canActivateTemplate
                },
                {
                    label: $scope.trns.addToBasket,
                    action: basketController.addToCurrentBasket,
                    type: 'dialogaction',
                    condition: basketController.canAddToCurrentBasket
                },
                {
                    label: $scope.trns.delete,
                    action: $scope.deleteBasket,
                    type: 'dialogaction',
                    condition: basketController.canDeleteBasket
                },
                {
                    label: $scope.trns.saveBasketAsTemplate,
                    action: $scope.saveBasketAsTemplate,
                    type: 'dialogaction',
                    condition: basketController.canSaveBasketAsTemplate
                },
                {
                    label: $scope.trns.addToBasket,
                    action: basketController.addItemsToCurrentBasket,
                    type: 'dialogaction',
                    condition: basketController.canAddItemsToCurrentBasket
                },
                {
                    label: $scope.trns.replaceItem,
                    action: basketController.replaceItem,
                    type: 'dialogaction',
                    condition: basketController.canReplaceItem
                },
                {
                    label: $scope.trns.duplicate,
                    action: basketController.duplicateItem,
                    type: 'dialogaction',
                    condition: basketController.canDuplicateItem
                },
                {
                    label: $scope.trns.changeReferences,
                    action: basketController.editReferences,
                    type: 'dialogaction',
                    condition: basketController.canEditReferences
                },
                {
                    label: $scope.trns.enterCode,
                    action: basketController.showCodeInput,
                    type: 'dialogaction',
                    condition: basketController.canEnterCode
                },
                {
                    label: $scope.trns.print,
                    type: 'print',
                    condition: basketController.hasNothingSelected,
                    params: {
                        printToken: $scope.printTokens.header,
                        prePrintAction: $scope.saveBasketBackground
                    }
                },
                {
                    label: $scope.trns.validateOCI,
                    action: basketController.validateOCIItem,
                    type: 'dialogaction',
                    condition: basketController.supportsValidateOCI
                },
                {
                    label: $scope.trns.detailOCI,
                    action: basketController.detailOCIItem,
                    type: 'dialogaction',
                    condition: basketController.supportsDetailOCI
                },
                {
                    label: $scope.trns.validateSAP,
                    action: basketController.validateSAPBasket,
                    type: 'validation',
                    condition: basketController.supportsValidateSAP,
                    params: {
                        form: $scope.dialogData
                    }
                },
                {
                    label: $scope.trns.scannerImport,
                    action: basketController.uploadScannerFile,
                    type: 'dialogaction',
                    condition: basketController.canUseScannerImport
                },
                {
                    label: $scope.trns.addresses,
                    action: basketController.showBulkDialogAddress,
                    type: 'dialogaction',
                    condition: basketController.canBulkChangeItemData
                },
                {
                    label: $scope.trns.dates,
                    action: basketController.showBulkDialogDate,
                    type: 'dialogaction',
                    condition: basketController.canBulkChangeItemData
                },
                {
                    label: $scope.trns.control,
                    action: basketController.showBulkDialogControl,
                    type: 'dialogaction',
                    condition: basketController.canBulkChangeItemData
                },
                {
                    label: $scope.trns.shareStatusButton,
                    action: basketController.toggleSupplierShare,
                    condition: basketController.canEditSupplierShareAndHasSupplierSelected,
                    type: 'dialogaction'
                },
                {
                    label: $scope.trns.shareStatusButton,
                    action: basketController.toggleHeaderShare,
                    condition: basketController.canEditHeaderShare,
                    type: 'dialogaction'
                },
                {
                    label: $scope.trns.forwardBasket,
                    action: basketController.showForwardBasketDialog,
                    condition: basketController.canForwardBasket,
                    type: 'dialogaction'
                },
                {
                    label: $scope.trns.excelUpload,
                    action: basketController.importBulkOrder,
                    condition: basketController.canImportBulkOrder,
                    type: 'dialogaction',
                    process: 'ImportBulkOrders'
                }
            ];
        }

        if (!$scope.data.basket.isTemplate) {
            ToolbarService.hideBackButton();
        }
        ToolbarService.setButtons($scope.buttonDefinition);
        $scope.numberOfItems.value = 0;
        if ($scope.data && $scope.data.basket) {
            var numOfItems = 0;
            $scope.scrollList = [];
            handleControlDataForChips(!basketController.useBasketControlDialog() && $scope.data.basket.control);
            if ($scope.data.basket.comments) {
                if ($scope.data.basket.comments.internalComments) {
                    $scope.data.basket.comments.internalComments.newComments = [];
                }
                if ($scope.data.basket.comments.externalComments) {
                    $scope.data.basket.comments.externalComments.newComments = [];
                }
            }
            var basketSupplierList = [];
            var showGross = $scope.data.basket.showGross && !$scope.data.basket.showCatalogNet;
            var showNet = $scope.data.basket.showNet || ($scope.data.basket.showGross && $scope.data.basket.showCatalogNet);
            $scope.sendDemandIgnoreFields = ["deliveryDate"];
            if ($scope.data.basket.addressConflicts) {
                for (var k = 0; k < $scope.data.basket.addressConflicts.length; k++) {
                    $scope.errorListForSend.push($scope.data.basket.addressConflicts[k].message);
                }
            }
            for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
                var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
                $scope.sendDemandIgnoreFields.push("hidden" + basketSupplier.id);
                $scope.sendDemandIgnoreFields.push("deliveryDateBKS" + basketSupplier.id);
                $scope.sendDemandIgnoreFields.push("hiddenSPO" + basketSupplier.id);
                var label = basketSupplier.contractName ? basketSupplier.contractName : "";
                label += basketSupplier.contractNo ? (" (" + basketSupplier.contractNo + ")") : "";
                if (basketSupplier.deliveryDate)
                {
                    if (basketSupplier.deliveryDate.minDate) {
                        basketSupplier.deliveryDate.minDate = new Date(basketSupplier.deliveryDate.minDate);
                    }
                    if (basketSupplier.deliveryDate.maxDate) {
                        basketSupplier.deliveryDate.maxDate = new Date(basketSupplier.deliveryDate.maxDate);
                    }
                }
                if (basketSupplier.price) {
                    if (showGross) {
                        label += " (" + $scope.trns.gross + " " + $filter('number')(basketSupplier.price.totalGrossValue / 100, 2) + " " + basketSupplier.price.currency.selected.value + ")";
                    }
                    if (showNet) {
                        label += " (" + $scope.trns.net + " " + $filter('number')(basketSupplier.price.totalNetValue / 100, 2) + " " + basketSupplier.price.currency.selected.value + ")";
                    }
                }
                basketSupplierList.push({id: 'basket-supplier-' + i, label: label});
                if (basketSupplier.comments) {
                    if (basketSupplier.comments.internalComments) {
                        basketSupplier.comments.internalComments.newComments = [];
                    }
                    if (basketSupplier.comments.externalComments) {
                        basketSupplier.comments.externalComments.newComments = [];
                    }
                }
                handleControlDataForChips(!basketController.useBasketControlDialog() && basketSupplier.control);
                for (var j = 0; j < basketSupplier.basketItemList.length; j++) {
                    numOfItems++;
                    var basketItem = basketSupplier.basketItemList[j];
                    $scope.numberOfItems.value++;
                    basketController.copyControlStructureReference(basketItem.control, basketSupplier.ctrlRef);
                    basketController.copyAddressReference(basketItem, basketSupplier);
                    basketController.checkReferences(basketItem, basketSupplier);
                    // allow pre-set controls to not be part of available controls, only for bulk items
                    if (!basketItem.isBulkOrder) {
                        handleControlDataForChips(!basketController.useBasketControlDialog() && basketItem.control);
                    }
                    if (basketItem.deliveryDate) {
                        if (basketItem.deliveryDate.minDate) {
                            basketItem.deliveryDate.minDate = new Date(basketItem.deliveryDate.minDate);
                        }
                        if (basketItem.deliveryDate.maxDate) {
                            basketItem.deliveryDate.maxDate = new Date(basketItem.deliveryDate.maxDate);
                        }
                        if (basketSupplier.deliveryDate && basketSupplier.deliveryDate.notAllowedHolidayDays) {
                            basketItem.deliveryDate.notAllowedHolidayDays = basketSupplier.deliveryDate.notAllowedHolidayDays;
                        }
                    }
                    if (basketItem.noTimedBaseProductStockLeft && basketItem.noTimedBaseProductStockLeft.value) {
                        $scope.errorListForSend.push($scope.trns.position + " " + basketItem.position + ": " + basketItem.noTimedBaseProductStockLeft.label);
                    }
                    if (basketItem.notEnoughTimedBaseProductStockLeft && basketItem.notEnoughTimedBaseProductStockLeft.value) {
                        $scope.errorListForSend.push($scope.trns.position + " " + basketItem.position + ": " + basketItem.notEnoughTimedBaseProductStockLeft.label);
                    }
                }
            }
            if ($scope.trns.userNoOrder) {
                $scope.errorListForSend.push($scope.trns.userNoOrder);
            }
            if ($scope.trns.partnerContractNumberMissing) {
                $scope.errorListForSend.push($scope.trns.partnerContractNumberMissing);
            }
            if (!j) j = 0;
            var headerLabel = $scope.trns.headerData;
            headerLabel = headerLabel + " (" + i + " " +
                (i != 1 ? $scope.trns.contracts : $scope.trns.contract) + " / " + numOfItems + " " +
                (numOfItems != 1 ? $scope.trns.positions : $scope.trns.position) + ")";
            $scope.scrollList.push({id: 'header', label: headerLabel});

            if ($scope.data.basket.needsProcess) {
                $scope.scrollList.push({id: 'basket-header-process', label: $scope.trns.processData});
            }

            $scope.scrollList = $scope.scrollList.concat(basketSupplierList);

            if ($scope.data.basket.price) {
                var labelSummary;
                if (showGross && ($scope.data.basket.price.totalNetValue || $scope.data.basket.price.totalGrossValue)) {
                    labelSummary = $scope.trns.sum + " (" + $scope.trns.gross + " " + $filter('number')($scope.data.basket.price.totalGrossValue / 100, 2) + " " + $scope.data.basket.price.currency.selected.value + ")";
                    $scope.scrollList.push({id: 'basket-summary', label: labelSummary});
                }
                if (showNet && ($scope.data.basket.price.totalNetValue || $scope.data.basket.price.totalGrossValue)) {
                    labelSummary = $scope.trns.sum + " (" + $scope.trns.net + " " + $filter('number')($scope.data.basket.price.totalNetValue / 100, 2) + " " + $scope.data.basket.price.currency.selected.value + ")";
                    $scope.scrollList.push({id: 'basket-summary', label: labelSummary});
                }
            }

            if (basketController.checkShowApproval()) {
                $scope.scrollList.push({id: 'basket-approval', label: $scope.trns.approval});
            }

            if ($scope.data.basket.singleInvoice.visible) {
                $scope.scrollList.push({id: 'moreSettings', label: $scope.trns.moreSettings});
            }

            ToolbarService.setScrollMenu($scope.scrollList);
            $scope.numberOfSuppliers = $scope.data.basket.basketSupplierHeaderList.length;

            $scope.approver = $scope.data.basket.approver;

            $scope.deleteBasketItemSelection();

            basketController.refreshCompanyTemplateData();

            $scope.toggleDitributionListFlag(true);
            if ($scope.data.basket.oneOciValidationFailed) {
                var warnings = [];
                var errors = [];
                for (var warningIter = 0; warningIter < $scope.data.basket.ociValidationWarnings.length; warningIter++) {
                    warnings.push({warning: $scope.data.basket.ociValidationWarnings[warningIter]})
                }
                for (var errorIter = 0; errorIter < $scope.data.basket.ociValidationErrors.length; errorIter++) {
                    errors.push({error: $scope.data.basket.ociValidationErrors[errorIter]})
                }
                $errorHandler.showErrors(errors, null, null, false, warnings);
            }
        }
    };

    this.checkReferences = function (basketItem, basketSupplier) {
        if (basketItem.isSelectReferenceMain) {
            var foundComponent = false;
            for (var l = 0; l < basketSupplier.basketItemList.length; l++) {
                var iteratorItem = basketSupplier.basketItemList[l];
                if (iteratorItem.selectGroup > 0 && iteratorItem.selectGroup === basketItem.selectGroup &&
                    iteratorItem.id !== basketItem.id) {
                    foundComponent = true;
                    break;
                }
            }
            if (!foundComponent) {
                $scope.errorListForSend.push($scope.trns.referenceError.replace("^0", basketItem.position).replace("^1", basketItem.name.value));
            }
        }
    };

    this.checkShowApproval = function () {
        return $scope.data.basket.approval && !$scope.data.basket.isTemplate && !$scope.isExternalGuest.value && !$scope.data.basket.isDispositionTemplate;
    }

    $scope.deleteBasketItemSelection = function () {
        for (var i = 0; i < $scope.selectedBasketItems.length; i++) {
            $scope.selectedBasketItems[i].selected = false;
        }
        $scope.selectedBasketItems = [];
        $scope.selectedBasketSupplier.splice(0, 1);
    };

    $scope.deleteBasket = function () {
        var wasDispositionAnswer = $scope.data.basket.isDispositionAnswer;
        var wasTemplate = false;
        if ($scope.data.basket.isCompanyTemplate || $scope.data.basket.isUserTemplate) {
            wasTemplate = true;
        }
        $scope.lastBasketDeleted = $scope.data.basket.id;
        $scope.wasActive = $scope.data.basket.isActive;
        var dataObj = {
            id: $scope.data.basket.id,
            withNewData: false
        };
        dataGen.post({}, dataObj, "/basket/delete", function (data) {
            $scope.noSave = true;
            if (!data.data.completeDelete && !wasDispositionAnswer) {
                $scope.showBasketDeletionToast($scope.lastBasketDeleted, $scope.wasActive ? $scope.wasActive : false);
            }
            else {
                ToastService.openStandardToast($scope.trns.basketDeleteMessage);
            }

            /* show deletion toast on success */
            $context.refreshBasket({}, dataGen, $context);
            if (wasTemplate) {
                basketTemplateMenu.refreshAllTemplates();
            }
            $redirect.redirectTo(null, $workspace.containsView("templateandbasketlist") ? "/templateandbasketlist" : "/basketlist");
        });
    };

    $scope.saveBasketAsTemplate = function (event) {
        var warnings = basketController.getSaveAsTemplateWarnings($scope.data.basket);
        WarningService.showWarningDialog(basketController.saveBasketAsTemplate, event, $scope.trns.warning, $scope.trns.save,
            $scope.trns.abort, warnings, $scope.data.basket);
    };

    this.getSaveAsTemplateWarnings = function (basket) {
        var warnings = [];
        var ignoreBKICount = 0;
        var maxCount = 0;
        angular.forEach(basket.basketSupplierHeaderList, function (supplierHeader) {
            angular.forEach(supplierHeader.basketItemList, function (basketItem) {
                maxCount++;
                if (basketItem.isIgnoreRights) {
                    ignoreBKICount++;
                }
            });
        });
        if (ignoreBKICount > 0) {
            warnings.push($scope.trns.positionRightsWarning.replace("^0", maxCount - ignoreBKICount));
        }
        warnings.push($scope.trns.onlyItemSaveWarning);
        return warnings;
    };

    this.saveBasketAsTemplate = function (basket) {
        basketController.removeAvailableLists($scope.data.basket);
        dataGen.postAsForm($scope, {basket: basket}, "/basket/saveastemplate").then(function () {
            basketTemplateMenu.refreshAllTemplates();
            $context.refreshBasket({}, dataGen, $context);
            $scope.noSave = true;
            $redirect.redirectTo(null, $workspace.containsView("templateandbasketlist") ? "/templateandbasketlist" : "/basketlist");
            ToastService.openStandardToast($scope.trns.saveSuccess);
        }, function () {
            basketTemplateMenu.refreshAllTemplates();
            basketController.addAllAvailableLists($scope.data.basket);
        });
    };

    this.getToDeleteArray = function (toDelete, sameGroup, otherPositions) {
        angular.forEach(toDelete, function (selectedBasketItem) {
            var grouped = false;
            if (selectedBasketItem.infoGroup > 0) {
                grouped = true;
                angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                    angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                        if (supplierItem.infoGroup > 0 && supplierItem.infoGroup === selectedBasketItem.infoGroup) {
                            if (sameGroup.indexOf(supplierItem) < 0) {
                                sameGroup.push(supplierItem);
                            }
                            if (toDelete.indexOf(supplierItem) < 0) {
                                toDelete.push(supplierItem);
                            }
                        }
                    });
                })
            }
            if (selectedBasketItem.basketMandatoryGroup > 0 && selectedBasketItem.isBundleItem) {
                grouped = true;
                angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                    angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                        if (supplierItem.basketMandatoryGroup > 0 && supplierItem.basketMandatoryGroup === selectedBasketItem.basketMandatoryGroup) {
                            if (sameGroup.indexOf(supplierItem) < 0) {
                                sameGroup.push(supplierItem);
                            }
                            if (toDelete.indexOf(supplierItem) < 0) {
                                toDelete.push(supplierItem);
                            }
                        }
                    });
                })
            }
            if (selectedBasketItem.basketItemGroupId > 0 && selectedBasketItem.isBundleItem) {
                grouped = true;
                angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                    angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                        if (supplierItem.basketItemGroupId > 0 && supplierItem.basketItemGroupId === selectedBasketItem.basketItemGroupId) {
                            if (sameGroup.indexOf(supplierItem) < 0) {
                                sameGroup.push(supplierItem);
                            }
                            if (toDelete.indexOf(supplierItem) < 0) {
                                toDelete.push(supplierItem);
                            }
                        }
                    });
                })
            }
            if (selectedBasketItem.isSelectReferenceMain || (selectedBasketItem.selectGroup > 0 && selectedBasketItem.isBundleItem)) {
                var hasComponentInBasket = false;
                var keepReferences = AppConfiguration.get('automaticSelectGroupCreation') && !(selectedBasketItem.selectGroup > 0 && selectedBasketItem.isBundleItem);
                grouped = true;
                angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                    angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                        if (supplierItem.selectGroup > 0 && supplierItem.selectGroup === selectedBasketItem.selectGroup &&
                            (!keepReferences || supplierItem.isSelectReferenceMain || supplierItem.isSelectReferenceComponent)) {
                            if (sameGroup.indexOf(supplierItem) < 0 && supplierItem.id !== selectedBasketItem.id) {
                                sameGroup.push(supplierItem);
                                hasComponentInBasket = true;
                            }
                            if (toDelete.indexOf(supplierItem) < 0) {
                                toDelete.push(supplierItem);
                            }
                        }
                    });
                });
                if (hasComponentInBasket && sameGroup.indexOf(selectedBasketItem) < 0) {
                    sameGroup.push(selectedBasketItem);
                }
            }
            if (!grouped && sameGroup.indexOf(selectedBasketItem) < 0 && otherPositions.indexOf(selectedBasketItem) < 0) {
                otherPositions.push(selectedBasketItem);
            }
        });
    };

    this.deleteBasketItemGroup = function (event, basketItemGroupId) {
        var selectedItems = [];
        for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
            var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
            for (var j = 0; j < basketSupplier.basketItemList.length; j++) {
                if (basketSupplier.basketItemList[j].basketItemGroupId === basketItemGroupId) {
                    selectedItems.push(basketSupplier.basketItemList[j]);
                }
            }
        }
        $scope.deleteItems(event, selectedItems);
    };

    $scope.deleteItems = function (event, selectedItems) {
        var optionalBasketMandatoryDeletion = [];
        if (!selectedItems) {
            selectedItems = $scope.selectedBasketItems;
        }
        for (var i = 0; i < selectedItems.length; i++) {
            var iteratorItem = selectedItems[i];
            var foundNotDeletedItemOfSameBasketMandatoryGroup = false;
            var optionalItemsForIteratorItem = [];
            if (iteratorItem.basketMandatoryGroup > 0 && !iteratorItem.isBundleItem) {
                var groupHandled = false;
                angular.forEach(optionalBasketMandatoryDeletion, function (group) {
                    if (group.group === iteratorItem.basketMandatoryGroup) {
                        groupHandled = true;
                    }
                });

                if (!groupHandled) {
                    angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                        angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                            if (supplierItem.basketMandatoryGroup > 0 && supplierItem.basketMandatoryGroup === iteratorItem.basketMandatoryGroup
                                && supplierItem !== iteratorItem) {
                                if (selectedItems.indexOf(supplierItem) < 0) {
                                    foundNotDeletedItemOfSameBasketMandatoryGroup = true;
                                }
                                optionalItemsForIteratorItem.push(supplierItem);
                            }
                        });
                    });
                    if (foundNotDeletedItemOfSameBasketMandatoryGroup) {
                        optionalItemsForIteratorItem.push(iteratorItem);
                        optionalBasketMandatoryDeletion.push({
                            group: iteratorItem.basketMandatoryGroup,
                            optionalItems: optionalItemsForIteratorItem
                        });
                    }
                }
            }
        }

        if (optionalBasketMandatoryDeletion.length > 0) {
            $mdDialog.show({
                controller: "BasketItemDeletionBasketMandatoryCtrl",
                controllerAs: "basketItemDeletionBasketMandatoryCtrl",
                templateUrl: "modules/basket/templates/basketitemdeletionbasketmandatory.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    basket: $scope.data.basket,
                    optionalBasketMandatoryDeletion: optionalBasketMandatoryDeletion,
                    selectedBasketItems: selectedItems,
                    headerLabel: $scope.trns.basketMandatoryGroupQuestion,
                    groupLabel: $scope.trns.group,
                    referencesLabel: $scope.trns.references
                }
            }).then(function () {
                $scope.handleGroupsAndDeleteItems(event, selectedItems);
            }, function () {
            });
        }
        else {
            $scope.handleGroupsAndDeleteItems(event, selectedItems);
        }
    };

    $scope.handleGroupsAndDeleteItems = function (event, selectedItems) {
        if (!selectedItems) {
            selectedItems = $scope.selectedBasketItems;
        }
        var toDelete = [];
        for (var i = 0; i < selectedItems.length; i++) {
            toDelete.push(selectedItems[i]);
        }
        var otherPositions = [];
        var sameGroup = [];

        while (true) {
            var oldSize = toDelete.length;
            basketController.getToDeleteArray(toDelete, sameGroup, otherPositions);
            if (toDelete.length === oldSize) {
                break;
            }
        }

        if (sameGroup.length > 0) {
            $mdDialog.show({
                controller: "BasketItemDeletionCtrl",
                controllerAs: "basketItemDeletionCtrl",
                templateUrl: "modules/basket/templates/basketitemdeletion.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    message: $scope.trns.canOrderedTogether,
                    otherMessage: $scope.trns.additionalPositions,
                    warning: $scope.trns.removePositions,
                    positions: sameGroup,
                    otherPositions: otherPositions,
                    saveLabel: $scope.trns.delete,
                    abortLabel: $scope.trns.abort
                }
            }).then(function () {
                if ($scope.deletionToastInProgress) {
                    $scope.finalDeletion($scope.lastDeleted).then(function () {
                        $scope.realDelete(toDelete);
                    })
                }
                else {
                    $scope.realDelete(toDelete);
                }
            }, function () {
            });
        }
        else {
            if ($scope.deletionToastInProgress) {
                if ($scope.deletionToastInProgress) {
                    $scope.finalDeletion($scope.lastDeleted).then(function () {
                        $scope.realDelete(toDelete);
                    })
                }
            }
            else {
                $scope.realDelete(toDelete);
            }
        }
    };

    $scope.rejectItem = function (event, bundleItem, basketItem) {
        var sameGroup = [];
        basketController.getItemsOfSameGroupForBundle(basketItem, sameGroup);

        if (sameGroup.length > 0) {
            $mdDialog.show({
                controller: "BasketItemDeletionCtrl",
                controllerAs: "basketItemDeletionCtrl",
                templateUrl: "modules/basket/templates/basketitemdeletion.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    message: $scope.trns.canOrderedTogether,
                    otherMessage: $scope.trns.additionalPositions,
                    warning: $scope.trns.rejectPositions,
                    positions: sameGroup,
                    otherPositions: [],
                    saveLabel: $scope.trns.reject,
                    abortLabel: $scope.trns.abort
                }
            }).then(function () {
                basketController.realRejectItem(bundleItem);
            }, function () {
            });
        }
        else {
            basketController.realRejectItem(bundleItem);
        }
    };

    $scope.unbundleItem = function (event, bundleItem, basketItem) {
        var sameGroup = [];
        basketController.getItemsOfSameGroupForBundle(basketItem, sameGroup);

        if (sameGroup.length > 0) {
            $mdDialog.show({
                controller: "BasketItemDeletionCtrl",
                controllerAs: "basketItemDeletionCtrl",
                templateUrl: "modules/basket/templates/basketitemdeletion.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    message: $scope.trns.canOrderedTogether,
                    otherMessage: $scope.trns.additionalPositions,
                    warning: $scope.trns.unbundlePositions,
                    positions: sameGroup,
                    otherPositions: [],
                    saveLabel: $scope.trns.unbundle,
                    abortLabel: $scope.trns.abort
                }
            }).then(function () {
                basketController.realUnbundleItem(bundleItem);
            }, function () {
            });
        }
        else {
            basketController.realUnbundleItem(bundleItem);
        }
    };

    this.getItemsOfSameGroupForBundle = function (basketItem, sameGroup) {
        if (basketItem.infoGroup > 0) {
            angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                    if (supplierItem.infoGroup > 0 && supplierItem.infoGroup === basketItem.infoGroup) {
                        if (sameGroup.indexOf(supplierItem) < 0) {
                            sameGroup.push(supplierItem);
                            basketController.getItemsOfSameGroupForBundle(supplierItem, sameGroup);
                        }
                    }
                });
            })
        }
        if (basketItem.basketMandatoryGroup > 0) {
            angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                    if (supplierItem.basketMandatoryGroup > 0 && supplierItem.basketMandatoryGroup === basketItem.basketMandatoryGroup) {
                        if (sameGroup.indexOf(supplierItem) < 0) {
                            sameGroup.push(supplierItem);
                            basketController.getItemsOfSameGroupForBundle(supplierItem, sameGroup);
                        }
                    }
                });
            })
        }
        if (basketItem.basketItemGroupId > 0) {
            angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                    if (supplierItem.basketItemGroupId > 0 && supplierItem.basketItemGroupId === basketItem.basketItemGroupId) {
                        if (sameGroup.indexOf(supplierItem) < 0) {
                            sameGroup.push(supplierItem);
                            basketController.getItemsOfSameGroupForBundle(supplierItem, sameGroup);
                        }
                    }
                });
            })
        }
        if (basketItem.selectGroup > 0) {
            var hasComponentInBasket = false;
            angular.forEach($scope.data.basket.basketSupplierHeaderList, function (supplierHeader) {
                angular.forEach(supplierHeader.basketItemList, function (supplierItem) {
                    if (supplierItem.selectGroup > 0 && supplierItem.selectGroup === basketItem.selectGroup) {
                        if (sameGroup.indexOf(supplierItem) < 0 && supplierItem.id !== basketItem.id) {
                            sameGroup.push(supplierItem);
                            hasComponentInBasket = true;
                            basketController.getItemsOfSameGroupForBundle(supplierItem, sameGroup);
                        }
                    }
                });
            });
            if (hasComponentInBasket && sameGroup.indexOf(basketItem) < 0) {
                sameGroup.push(basketItem);
            }
        }
        return sameGroup;
    };

    this.realRejectItem = function (bundleItem) {
        if (!deletionInProgress) {
            deletionInProgress = true;
            $scope.saveBasketBackground().then(function () {
                dataGen.postAsForm({}, {bkiId: bundleItem.id}, "/basket/item/reject").then(function () {
                    $scope.getBasket();
                    $context.refreshBasket({}, dataGen, $context);
                    deletionInProgress = false;
                }, function () {
                    deletionInProgress = false;
                })
            });
        }
    };

    this.realUnbundleItem = function (bundleItem) {
        if (!deletionInProgress) {
            deletionInProgress = true;
            $scope.saveBasketBackground().then(function () {
                dataGen.postAsForm({}, {bkiId: bundleItem.id}, "/basket/item/unbundle").then(function () {
                    $scope.getBasket();
                    $context.refreshBasket({}, dataGen, $context);
                    deletionInProgress = false;
                }, function () {
                    deletionInProgress = false;
                })
            });
        }
    };


    $scope.realDelete = function (toDelete) {
        if (!deletionInProgress) {
            deletionInProgress = true;
            basketController.removeAvailableLists($scope.data.basket);
            var i;
            $scope.lastDeleted = [];
            if (!toDelete) {
                toDelete = $scope.selectedBasketItems;
            }
            for (i = 0; i < toDelete.length; i++) {
                toDelete[i].selected = false;
                $scope.lastDeleted[i] = toDelete[i];
            }
            $scope.selectedBasketItems = [];
            var dataObj = {
                basket: $scope.data.basket,
                deleted: $scope.lastDeleted
            };
            dataGen.postAsForm($scope, dataObj, "/basket/items/delete").then(function (data) {
                $scope.deleteBasketItemSelection();
                $scope.data = data.data;
                if (!data.data.completeDelete) {
                    /* show deletion toast on success */
                    $scope.showDeletionToast($scope.lastDeleted);
                }
                else {
                    ToastService.openStandardToast($scope.getDeleteLabel());
                }
                $scope.handleData();
                $context.refreshBasket({}, dataGen, $context);
                deletionInProgress = false;
            }, function () {
                basketController.addAllAvailableLists($scope.data.basket);
                deletionInProgress = false;
            });
        }
    };

    $scope.showDeletionToast = function (lastDeleted) {
        /* needed for route change. it will trigger the final deletion if route changes before toast is hidden. */
        $scope.deletionToastInProgress = true;

        ToastService.openActionToast($scope.getDeleteLabel(), TranslationService.get('revert'), $scope.revertDeletion, function () {
            $scope.finalDeletion(lastDeleted);
            $scope.deletionToastInProgress = false;
        });
    };
    $scope.showBasketDeletionToast = function (lastBasketDeleted, wasActive) {
        $mdToast.show({
            templateUrl: 'modules/basket/includes/basket-deletion-toast-template.html',
            hideDelay: 10000,
            preserveScope: true,
            position: "bottom right",
            controller: "BasketDeletionCtrl",
            controllerAs: 'basketDeletionCtrl',
            locals: {
                id: lastBasketDeleted,
                basketdeletionlabel: $scope.trns.basketDeleteMessage,
                revertbuttonlabel: $scope.trns.revert,
                active: wasActive,
                withnewdata: true
            }
        }).then(function (response) {
            if (response != 'reverted') {
                // $scope.finalBasketDeletion();
            }
        })
        ;
    };
    $scope.$on('$locationChangeStart', function (event) {
        if (!$scope.noSave) {
            $scope.saveBasketBackground(true);
        }
        if ($scope.deletionToastInProgress) {
            $mdToast.hide();
            $scope.finalDeletion($scope.lastDeleted);
        }
    });
    $scope.finalDeletion = function (items) {
        //Check if still authorized. Could already be logged off.
        if ($securityManager.isAuthorized()) {
            var dataObj = {
                lastDeleted: items
            };

            return dataGen.postAsForm($scope, dataObj, "/basket/items/finaldelete", false, true);
        }
    };

    this.updateFileSize = function () {
        for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
            var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
            if (basketSupplier.fileSize) {
                dataGen.getData({}, {bksId: basketSupplier.id}, "/basket/bks/filesize").then(function (data) {
                    basketSupplier.fileSize = data.data;
                });
            }
        }
    }

    $scope.finalBasketDeletion = function (id) {
        //todo: is this needed? the basket is deprecated, the items and bks under the basket are deprecated. shouldn't bother us anymore.
        /*
         var dataObj = {
         lastDeleted: id
         };

         dataGen.post($scope, dataObj, "/basket/finaldelete", function (data)
         {

         }, true);*/
    };
    $scope.revertDeletion = function () {
        $mdToast.hide("reverted");
        var dataObj = {
            data: $scope.data,
            reverted: $scope.lastDeleted
        };

        dataGen.post($scope, dataObj, "/basket/items/revertdeletion").then(function (data) {
            $scope.deleteBasketItemSelection();
            $scope.data = data.data;
            $scope.handleData();
            $context.refreshBasket({}, dataGen, $context);
        }, function () {
            basketController.addAllAvailableLists($scope.data.basket);
        });
        $scope.lastDeleted = [];
    };

    $scope.getDeleteLabel = function () {
        var returnString = $scope.data.numberOfDeletedItems + " ";
        if ($scope.data.numberOfDeletedItems != 1) {
            returnString += $scope.trns.deletedItemPlural;
        }
        else {
            returnString += $scope.trns.deletedItemSingular;
        }
        return returnString;
    };

    var mainView = angular.element("#main-content");
    mainView.bind("scroll", function () {
        $scope.placeRefreshButton();
    });

    $scope.placeRefreshButton = function () {
        if ($scope.basketHasChanged) {
            var summaryElement = angular.element('#basket-summary');
            var stickyButtonElement = angular.element('#stickyRefreshButton');

            var middle = (summaryElement.offset().top + summaryElement.height());
            if (middle < (mainView.offset().top + mainView.height())) {
                stickyButtonElement.css({
                    "position": "absolute",
                    "bottom": "",
                    "right": "24px",
                    "top": "30%"
                });
            }
            else {
                stickyButtonElement.css({
                    "position": "fixed",
                    "bottom": "32px",
                    "right": "48px",
                    "top": ""
                });
            }
        }
    };

    $scope.markBasketAsChanged = function (isValid) {
        if (isValid !== undefined) {
            $scope.basketHasChanged = isValid;
        }
        else {
            $scope.basketHasChanged = true;
        }
    };

    $scope.selectLastSelected = function () {
        if (lastSelectedItems.length > 0 || lastSelectedSupplierHeaders.length > 0) {
            for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
                var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
                if (lastSelectedSupplierHeaders.indexOf(basketSupplier.id) >= 0) {
                    $scope.selectedBasketSupplier.push(basketSupplier);
                }
                if (lastSelectedItems.length > 0) {
                    for (var j = 0; j < basketSupplier.basketItemList.length; j++) {
                        var basketItem = basketSupplier.basketItemList[j];
                        if (lastSelectedItems.indexOf(basketItem.id) >= 0) {
                            basketItem.selected = true;
                            $scope.selectedBasketItems.push(basketItem);
                        }
                    }
                }
            }
        }
        lastSelectedItems = [];
        lastSelectedSupplierHeaders = [];
    };

    $scope.saveBasketBackground = function (noUpdateView) {
        if ($securityManager.getToken() && $securityManager.isProcessAllowed("ViewBasket") && $scope.data.basket && $scope.data.basket.basketSupplierHeaderList && !$scope.getInProgress) {
            basketController.removeAvailableLists($scope.data.basket);
            var dataObj = {
                data: $scope.data,
                backgroundSave: true,
                withNewData: !noUpdateView
            };
            var wasTemplate = $scope.data.basket.isCompanyTemplate || $scope.data.basket.isUserTemplate;
            basketController.startUniteOptimizationWatch();
            return dataGen.post(noUpdateView ? {} : $scope, dataObj, "/basket/save").then(function () {
                if (!noUpdateView) {
                    $scope.handleData();
                }
                else {
                    if (wasTemplate) {
                        basketTemplateMenu.refreshAllTemplates();
                    }
                }
            }, function () {
                basketController.addAllAvailableLists($scope.data.basket);
            }).finally(function () {
                basketController.stopUniteOptimizationWatch();
            });
        }
    };
    $scope.saveBasket = function () {
        basketController.removeAvailableLists($scope.data.basket);
        var dataObj = {
            data: $scope.data,
            backgroundSave: false,
            withNewData: true,
            dataHasChanged: $scope.basketHasChanged
        };

        basketController.startUniteOptimizationWatch();
        return dataGen.post($scope, dataObj, "/basket/save").then(function () {
            $context.refreshBasket({}, dataGen, $context);
            $scope.handleData();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $scope.basketHasChanged = false;

        }, function () {
            $scope.deleteBasketItemSelection();
            basketController.addAllAvailableLists($scope.data.basket);
        }).finally(function () {
            basketController.stopUniteOptimizationWatch();
        });

    };

    $scope.orderBasketWarnings = function (event, proposalOrder, realBasketOrder, type) {
        if (!$scope.orderRequestInProgress) {
            $scope.orderRequestInProgress = true;
            $scope.orderRequestType = type;
            dataGen.postAsForm({}, {bkhId: $scope.data.basket.id}, "/basket/checkminordercontentamount").then(function (data) {
                if (data && data.data.hasErrors) {
                    $mdDialog.show({
                        controller: "CheckMinOrderContentAmountDialogCtrl",
                        controllerAs: 'checkMinOrderContentAmountDialogCtrl',
                        templateUrl: "modules/basket/templates/checkminordercontentamountdialog.tmpl.html",
                        parent: angular.element(document.body),
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            data: data.data,
                            trns: data.trns
                        }
                    });
                    disableRequestIndication();
                }
                else {
                    $scope.orderRequestInProgress = true;
                    $scope.orderRequestType = type;
                    dataGen.postAsForm($scope, {basketHeaderDTO: $scope.data.basket}, "/basket/orderwarnings").then(function (data) {
                        $context.refreshBasket({}, dataGen, $context)
                        $scope.handleData();
                        if (data.data.warnings && data.data.warnings.length > 0) {
                            return WarningService.showWarningDialog($scope.agreementTextDialogOneParam, event, $scope.trns.warning, $scope.trns.orderAnyway,
                                $scope.trns.abort, data.data.warnings, {
                                    event: event,
                                    proposalOrder: proposalOrder,
                                    realBasketOrder: realBasketOrder,
                                    type: type,
                                    data: data.data
                                }).finally(disableRequestIndication);
                        }
                        else {
                            return $scope.agreementTextDialog(event, proposalOrder, realBasketOrder, type, data.data);
                        }
                    }, disableRequestIndication);
                }
            }, disableRequestIndication);
        }
    };

    $scope.agreementTextDialogOneParam = function (paramObject) {
        var event = paramObject.event;
        var proposalOrder = paramObject.proposalOrder;
        var realBasketOrder = paramObject.realBasketOrder;
        var type = paramObject.type;
        var data = paramObject.data;

        var result = checkAgreementTextAndOGDAndSubsequent();

        return handleAgreementText(event, result).then(function () {
            return handleOGDAndSubsequentDialogs(event, result).then(function () {
                return handleSubsequentOrderDialogs(event, proposalOrder).then(function () {
                    return handleAWD(event, data.needsAWD).then(function() {
                        return $scope.orderBasket(event, 0, result, proposalOrder, realBasketOrder, type).then(angular.noop).finally(disableRequestIndication);
                    })
                }).finally(disableRequestIndication);
            }, function () {
                if (result.hasOGD) {
                    deleteOGDLOGRequest(result.allBksIds);
                }
                disableRequestIndication();
            });
        }).finally(disableRequestIndication);
    }

    $scope.agreementTextDialog = function (event, proposalOrder, realBasketOrder, type, data) {
        var result = checkAgreementTextAndOGDAndSubsequent();

        return handleAgreementText(event, result).then(function () {
            return handleOGDAndSubsequentDialogs(event, result).then(function () {
                return handleSubsequentOrderDialogs(event, proposalOrder).then(function () {
                    return handleAWD(event, data.needsAWD).then(function() {
                        return $scope.orderBasket(event, 0, result, proposalOrder, realBasketOrder, type).then(angular.noop).finally(disableRequestIndication);
                    })
                }).finally(disableRequestIndication);
            }, function () {
                if (result.hasOGD) {
                    deleteOGDLOGRequest(result.allBksIds);
                }
                disableRequestIndication();
            });
        }).finally(disableRequestIndication);
    };

    function disableRequestIndication() {
        $scope.orderRequestInProgress = false;
        $scope.orderRequestType = -1;
    }

    function handleAgreementText(event, result) {
        if (result.hasAgreementText) {
            var dataObj = {
                data: $scope.data
            };

            return $mdDialog.show({
                controller: "AgreementTextDialogCtrl",
                controllerAs: 'ctrl',
                templateUrl: "modules/basket/templates/agreementtextdialog.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    data: dataObj,
                    trns: $scope.trns
                }
            });
        }
        else {
            var defer = $q.defer();
            defer.resolve();
            return defer.promise;
        }
    }

    function handleSubsequentOrderDialogs(event, proposalOrder) {
        var defer = $q.defer();
        var basketSupplierHeadersFound = [];
        if (!proposalOrder) {
            for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
                var basketSupplierHeader = $scope.data.basket.basketSupplierHeaderList[i];

                if(basketSupplierHeader.subsequentPurchaseOrderEnabled && basketSupplierHeader.subsequentPurchaseOrderEnabled.value &&
                    basketSupplierHeader.subsequentPurchaseOrderOptional) {
                    basketSupplierHeadersFound.push(basketSupplierHeader);
                }
            }
        }

        if (basketSupplierHeadersFound.length > 0) {
            var contractNames = basketSupplierHeadersFound[0].contractName + " (" + basketSupplierHeadersFound[0].contractNo + ")";
            for (var j = 1; j < basketSupplierHeadersFound.length; j++) {
                contractNames += ", " + basketSupplierHeadersFound[0].contractName + " (" + basketSupplierHeadersFound[0].contractNo + ")";
            }
            var warning = basketSupplierHeadersFound.length > 1 ?
                $scope.trns.subsequentPurchaseOrderWarningNotSetMultiple.replace("^0", contractNames) :
                $scope.trns.subsequentPurchaseOrderWarningNotSet.replace("^0", contractNames);
            var warningConfirm = basketSupplierHeadersFound.length > 1 ?
                $scope.trns.subsequentPurchaseOrderWarningNotSetMultipleConfirm :
                $scope.trns.subsequentPurchaseOrderWarningNotSetConfirm;


            return WarningService.showWarningDialogNoCallback(event, $scope.trns.warning, TranslationService.get("confirm"),
                $scope.trns.abort, [warning, warningConfirm]);
        }
        else {
            defer.resolve();
            return defer.promise;
        }
    }

    function handleOGDAndSubsequentDialogs(event, result) {
        var defer = $q.defer();

        if (result.hasWarning) {
            return openOGDAgreementDialog(event, result.warningBksIds, true).then(function () {
                if (result.confirmationBksIds.length > 0) {
                    return openOGDAgreementDialog(event, result.confirmationBksIds, false);
                } else {
                    defer.resolve();
                    return defer.promise;
                }
            });
        }
        else {
            if (result.confirmationBksIds.length > 0) {
                return openOGDAgreementDialog(event, result.confirmationBksIds, false);
            }
            else {
                defer.resolve();
                return defer.promise;
            }
        }
    }

    function openOGDAgreementDialog(event, bksIds, isWarning) {
        return OpenGovernmentDataService.openAgreementDialog(event, bksIds, [], [], isWarning);
    }

    function deleteOGDLOGRequest(allBksIds) {
        if ($securityManager.isProcessAllowed("ReportOpenGovernmentData")) {
            dataGen.postAsForm({}, {bksIds: allBksIds}, "/opengovernmentdata/log/delete", false, true);
        }
    }

    function checkAgreementTextAndOGDAndSubsequent() {
        var warningBksIds = [];
        var confirmationBksIds = [];
        var allBksIds = [];
        var hasWarning = false;
        var hasOGD = false;
        var hasSubsequentData = false;

        var hasAgreementText = false;
        for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
            var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
            allBksIds.push(basketSupplier.id);

            if (basketSupplier.agreementText != null && basketSupplier.agreementText.length > 0) {
                hasAgreementText = true;
            }

            if(basketSupplier.subsequentPurchaseOrderEnabled && basketSupplier.subsequentPurchaseOrderEnabled.value) {
                hasSubsequentData = true;
            }

            var reportOGD = impactX.isDefined(basketSupplier, 'ogd.reportOGD');
            if (reportOGD) {
                hasOGD = true;
                if (reportOGD.secondValue && !reportOGD.value) {
                    hasWarning = true;
                    warningBksIds.push(basketSupplier.id);
                }
                if (reportOGD.value) {
                    confirmationBksIds.push(basketSupplier.id);
                }
            }
        }

        return {
            warningBksIds: warningBksIds,
            confirmationBksIds: confirmationBksIds,
            allBksIds: allBksIds,
            hasWarning: hasWarning,
            hasOGD: hasOGD,
            hasAgreementText: hasAgreementText,
            hasSubsequentData: hasSubsequentData
        };
    }

    $scope.orderBasket = function (ev, contractId, bksInfo, proposalOrder, realBasketOrder, type) {
        $scope.orderRequestInProgress = true;
        $scope.orderRequestType = type;
        if ($scope.isExternalGuest.value) {
            basketController.removeAvailableLists($scope.data.basket);
            var dataObj = {
                data: $scope.data,
                backgroundSave: false,
                withNewData: true
            };

            return dataGen.post($scope, dataObj, "/basket/save").then(function () {
                $scope.handleData();
                $scope.basketHasChanged = false;
                if ($scope.data.basket.isCXMLGuestUser) {
                    dataGen.postAsForm({}, {bkhId: $scope.data.basket.id}, "/basket/cxml/orderguest").then(function (data) {
                        sendBuySearchSignal();
                        $securityManager.invalidate();
                        $listCache.removeAll();
                        LogoutTimerService.clearLogoutTimer();
                        document.getElementsByTagName("body")[0].innerHTML = data.data.form;
                        $("form#orderBasket").submit();
                    }, disableRequestIndication);
                }
                else {
                    dataGen.postAsForm({}, {bkhId: $scope.data.basket.id}, "/basket/orderguest").then(function (data) {
                        sendBuySearchSignal();
                        document.getElementsByTagName("body")[0].innerHTML = data.data.form;
                        $("form#orderBasket").submit();
                    }, disableRequestIndication);
                }
            }, function () {
                $scope.deleteBasketItemSelection();
                basketController.addAllAvailableLists($scope.data.basket);
                disableRequestIndication();
            }).finally(disableRequestIndication);
        }
        else {
            basketController.removeAvailableLists($scope.data.basket);
            var dataObj = {
                data: $scope.data,
                contractId: contractId ? contractId : 0
            };
            if (!realBasketOrder && (proposalOrder || $scope.data.basket.isDemandBasket) && $scope.data.basket.dispatchDEHUsers &&
                $scope.data.basket.dispatchDEHUsers.entries.length > 0) {
                dataObj.proposalOrder = proposalOrder;
                return $mdDialog.show({
                    controller: "DemandDispatchDialogCtrl",
                    controllerAs: 'ctrl',
                    templateUrl: "modules/basket/templates/demanddispatchdialog.tmpl.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    locals: {
                        data: dataObj,
                        trns: $scope.trns
                    }
                }).then(function () {
                        var selectedUsrId = impactX.isDefined($scope, "data.basket.dispatchDEHUsers.selected.id");
                        if (selectedUsrId === $context.userId.value && !hasApproval()) {
                            // only if dispatch user is self and no approvers
                            return ixaBasketActions.openDemandSelfDispatchInfoDialog().then(function (result) {
                                if (result) {
                                    if (result.orderNow) {
                                        dataObj.realBasketOrder = true;
                                        proposalOrder = false;
                                        realBasketOrder = true;
                                        $scope.data.basket.isDemandBasket = false;
                                        delete $scope.data.basket.dispatchDEHUsers.selected;
                                        $scope.orderRequestType = 0;
                                    }
                                    return orderBasketInternal(dataObj, contractId, ev, bksInfo, proposalOrder);
                                }
                                $scope.handleData();
                            }, function () {
                                $scope.handleData();
                                disableRequestIndication();
                            });
                        }
                        return orderBasketInternal(dataObj, contractId, ev, bksInfo, proposalOrder);
                    }, function () {
                        $scope.handleData();
                        disableRequestIndication();
                    });
            }
            else {
                dataObj.realBasketOrder = realBasketOrder;
                return orderBasketInternal(dataObj, contractId, ev, bksInfo, proposalOrder);
            }
        }
    };

    function hasApproval() {
        return ($scope.data.basket.approval && $scope.data.basket.approval.isAutomaticApproval) ||
            ($scope.data.basket.approval && $scope.data.basket.approval.approvalSteps &&
                $scope.data.basket.approval.approvalSteps.filter(function (approvalStep) {
                return approvalStep.setEntries && approvalStep.setEntries.length > 0;
            }).length > 0)
    }

    function orderBasketInternal(dataObj, contractId, ev, bksInfo, proposalOrder) {
        return $scope.showProcessDialog(dataObj, function (dataObj) {
            return dataGen.post({}, dataObj, contractId > 0 ? "/basket/supplier/order" : "/basket/order").then(function (response) {
                sendBuySearchSignal();
                $context.refreshBasket({}, dataGen, $context);
                $scope.noSave = true;

                var toastText, targetRoute;
                if ($scope.data.basket.originalPohId > 0) {
                    toastText = $scope.trns.demandRequestSend;
                    targetRoute = '/orderchangedetails/' + $scope.data.basket.originalPohId;
                } else if ($scope.data.basket.isDispositionAnswer) {
                    toastText = $scope.trns.dispositionAnswerSend;
                    targetRoute = '/dispositionusertemplatelist';
                }
                else if (impactX.isDefined(response, 'data.isDemand')) {
                    toastText = $scope.trns.demandRequestSend;
                    targetRoute = BasketService.resolveLandingPage(impactX.isDefined(response, 'data.headerId'), true);
                }
                else {
                    toastText = $scope.trns.purchaseRequestSend;
                    targetRoute = BasketService.resolveLandingPage(impactX.isDefined(response, 'data.headerId'), false);
                }
                $redirect.redirectTo(null, targetRoute);
                ToastService.openStandardToast(toastText);
            }, function () {
                $scope.handleData();
            })
        }, ev, bksInfo, proposalOrder);
    }

    function sendBuySearchSignal(supplierHeaderList) {
        var proIds = [];
        angular.forEach(supplierHeaderList ? supplierHeaderList : $scope.data.basket.basketSupplierHeaderList, function (bks) {
            angular.forEach(bks.basketItemList, function (bki) {
                if (bki.productId) {
                    const proId = bki.productGroupNumber > 0? bki.productGroupNumber : bki.productId;
                    proIds.push(String(proId));
                }
            });
        });
        ixaSearchSignals.buy(proIds)
    }

    $scope.orderBasketRFQ = function () {
        dataGen.postAsForm({}, {basket: $scope.data.basket}, "/basket/orderrfq").then(function () {
            sendBuySearchSignal();
            $context.refreshBasket({}, dataGen, $context);
            $location.path("/basket");
            $route.reload();
            ToastService.openStandardToast($scope.trns.rfqSend);
        });
    };

    $scope.showProcessDialog = function (dataObj, func, ev, bksInfo, proposalOrder) {
        return $mdDialog.show({
            controller: "OrderProgressCtrl",
            controllerAs: "orderProgressCtrl",
            templateUrl: "modules/basket/templates/orderbasketprogress.html",
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            escapeToClose: false,
            locals: {
                basketData: dataObj,
                progressLabel: proposalOrder ? $scope.trns.progressLabelDemand : $scope.trns.progressLabelOrder,
                successFunction: func
            }
        }).then(angular.noop, function () {
            $scope.handleData();
            if (bksInfo.hasOGD) {
                deleteOGDLOGRequest(bksInfo.allBksIds);
            }
        });
    };

    /**
     * Retrieves the ID of the first selected item or the provided default value.
     * @param defaultValue (optional) default value if there is no first item selected. By default 0.
     *
     * @returns {number} ID of the first selected item or the default value.
     */
    $scope.getIdOfFirstSelectedBasketItem = function (defaultValue) {

        if ($scope.selectedBasketItems[0]) {
            return $scope.selectedBasketItems[0].id;
        }

        return angular.isNumber(defaultValue) ? defaultValue : 0;
    };

    this.showBasketItemOfferDialog = function (ev, basketItemGroupId) {
        $mdDialog.show({
            controller: "EditFreeFormOfferCtrl",
            controllerAs: "editFreeFormOfferCtrl",
            templateUrl: 'modules/basket/templates/freeformofferdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                basketItemGroupId: basketItemGroupId ? basketItemGroupId : 0,
                headerId: $scope.data.basket.id,
                hideOrderData: $scope.data.basket.isDispositionTemplate,
                lotId: 0, // no lot to reduce to
                supplierId: 0, // no fixed supplier,
                product: null,
                allowBANF: true,
                onlyBANF: false
            }
        })
            .then(function (answer) {
                if (answer && answer.freeformContract) {
                    $scope.showBasketItemDialog(ev, answer.freeformContract.id);
                }
                else {
                    $context.refreshBasket({}, dataGen, $context);
                    $scope.deleteBasketItemSelection();
                    $scope.getBasket(true);
                }
            }, function () {
            });
        $scope.saveBasketBackground();
        $scope.deleteBasketItemSelection();
    };


    $scope.showBasketItemDialog = function (ev, banfContractId) {
        //Default routes and controller
        var lotId = -1,
            entryPointGet = banfContractId && banfContractId > 0 ?"/basket/item/freeform/view/banf" : "/basket/item/view",
            entryPointSave = "/basket/item/save",
            controller = "EditRequestItemCtrl",
            basketItemId = $scope.getIdOfFirstSelectedBasketItem(0),
            aatEntryPoint = '/basket/item/changeaat';

        if (basketItemId == 0 || $scope.selectedBasketItems[0].isFreeform) {
            entryPointGet = "/basket/item/freeform/view";
            entryPointSave = "/basket/item/freeform/save";
            controller = "EditFreeFormCtrl";
            lotId = 0;
            aatEntryPoint = '/basket/item/updateavailablecontrols';
        }

        $mdDialog.show({
            controller: controller,
            templateUrl: 'shared/requestitem/templates/requestitemdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                itemId: basketItemId,
                headerId: $scope.data.basket.id,
                entryPointGet: entryPointGet,
                entryPointSave: entryPointSave,
                changeAATEntryPoint: aatEntryPoint,
                lotId: lotId,
                productId: -1,
                readOnly: false,
                materialGroupMappingEntryPoint: "/basket/input/eclassmapping",
                hideOrderData: $scope.data.basket.isDispositionTemplate,
                headerTable: "BKH",
                contractId: banfContractId
            }
        })
            .then(function () {
                $context.refreshBasket({}, dataGen, $context);
                $scope.deleteBasketItemSelection();
                $scope.getBasket(true);
            }, function () {
            });
        $scope.saveBasketBackground();
        $scope.deleteBasketItemSelection();
    };

    $scope.showGreetingCardDialog = function (ev) {
        $mdDialog.show({
            controller: 'BasketItemGreetingCardCtrl',
            controllerAs: 'basketItemGreetingCardCtrl',
            templateUrl: 'modules/greetingcard/templates/basketitemgreetingcard.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                bkiId: $scope.getIdOfFirstSelectedBasketItem(0)
            }
        }).then(function () {
            $scope.getInProgress = true;
            ToolbarService.setButtons([]);
            ToolbarService.recalcButtons(true);
            $context.refreshBasket({}, dataGen, $context);
            $scope.deleteBasketItemSelection();
            $scope.getBasket().finally(function() {$scope.getInProgress = false;});
        }, function () {
        });
        $scope.saveBasketBackground();
        $scope.deleteBasketItemSelection();
    };

    $scope.showVerificationDialog = function (ev) {
        $mdDialog.show({
            controller: 'BasketItemVerificationTraceCtrl',
            controllerAs: 'basketItemVerificationTraceCtrl',
            templateUrl: 'modules/greetingcard/templates/basketitemverificationtrace.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                bkiId: $scope.getIdOfFirstSelectedBasketItem(0)
            }
        }).then(function () {
            $scope.getInProgress = true;
            ToolbarService.setButtons([]);
            ToolbarService.recalcButtons(true);
            $context.refreshBasket({}, dataGen, $context);
            $scope.deleteBasketItemSelection();
            $scope.getBasket().finally(function() {$scope.getInProgress = false;});
        }, function () {
        });
        $scope.saveBasketBackground();
        $scope.deleteBasketItemSelection();
    };

    $scope.showCateringDialog = function (ev) {
        AddToBasketService.showCateringDialog($scope.selectedBasketItems[0].product, $scope.selectedBasketItems[0].id, ev).then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $scope.deleteBasketItemSelection();
            $scope.getBasket();
        })
    }

    $scope.toggleTemplate = function () {
        basketController.removeAvailableLists($scope.data.basket);
        var dataObj = {
            data: $scope.data
        };
        dataGen.post($scope, dataObj, "/disposition/toggletemplate", function (data) {
            $scope.deleteBasketItemSelection();
            $scope.data = data.data;
            $scope.handleData();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        }, function () {
            basketController.addAllAvailableLists($scope.data.basket);
        })
    };

    $scope.activateBasket = function () {
        var promise = $scope.saveBasketBackground();
        if (promise) {
            promise.then(function () {
                basketController.removeAvailableLists($scope.data.basket);
                var dataObj = {
                    data: $scope.data,
                    selected: [{id: $scope.data.basket.id}]
                };
                dataGen.post($scope, dataObj, "/basket/activate", function (data) {
                    $scope.getBasket();
                    ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                    $context.refreshBasket({}, dataGen, $context);
                }, function () {
                    basketController.addAllAvailableLists($scope.data.basket);
                })
            });
        }
    };

    this.deactivateBasket = function () {
        $scope.saveBasketBackground().then(function () {
            basketController.removeAvailableLists($scope.data.basket);

            dataGen.post($scope, {selected: [{id: 0}]}, "/basket/activate", function () {
                $scope.getBasket();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                $context.refreshBasket({}, dataGen, $context);
            })
        });
    };

    this.changeOutlet = function (outletId, suppHeaderId) {
        lastSelectedSupplierHeaders = [];
        basketController.removeAvailableLists($scope.data.basket);
        var dataObj = {
            basket: $scope.data.basket,
            suppHeaderId: suppHeaderId,
            outletId: outletId
        };
        return dataGen.postAsForm($scope, dataObj, "/basket/changeoutlet").then(function () {
            $scope.deleteBasketItemSelection();
            $scope.handleData();
            if ($scope.data.scrollToBKS) {
                $timeout(function () {
                    var target = angular.element('#main-content');
                    var topOffset = angular.element('#basketSupplierHeader' + $scope.data.scrollToBKS).offset().top + target.scrollTop();
                    target.scrollTop(topOffset - target.offset().top - 20);
                });
            }
        }, function () {
            basketController.addAllAvailableLists($scope.data.basket);
        });
    };

    this.changeProcess = function (pidId) {
        basketController.removeAvailableLists($scope.data.basket);
        var dataObj = {
            basket: $scope.data.basket,
            pidId: pidId
        };
        if (impactX.isDefined($scope, 'data.basket.processAttributesEditable')) {
            $scope.data.basket.processAttributesEditable = null;
        }
        dataGen.postAsForm($scope, dataObj, "/basket/changepid").then(function () {
            $scope.errorListProcess.length = 0;
            $scope.deleteBasketItemSelection();
            $scope.handleData();
        }, function () {
            basketController.addAllAvailableLists($scope.data.basket);
        })
    };
    this.changeAccountAssignment = function (aatId, oldAATId) {
        if (basketController.useBasketControlDialog()) {
            basketController.openHeaderControlDialog(null, aatId).then(angular.noop, function () {
                var oldAATSelected = undefined;
                if (oldAATId && impactX.isDefined($scope, 'data.basket.aat.entries')) {
                    for (var i = 0; i < $scope.data.basket.aat.entries.length; i++) {
                        if ($scope.data.basket.aat.entries[i].id == oldAATId) {
                            oldAATSelected = $scope.data.basket.aat.entries[i];
                            break;
                        }
                    }
                }
                $scope.data.basket.aat.selected = oldAATSelected;
            });
        }
        else {
            basketController.changeHeaderAAT(aatId);
        }
    };

    this.changeHeaderAAT = function (aatId) {
        basketController.removeAvailableLists($scope.data.basket);
        var dataObj = {
            basket: $scope.data.basket,
            suppHeaderId: 0,
            itemId: 0,
            aatId: aatId
        };
        return dataGen.postAsForm($scope, dataObj, "/basket/changeaat").then(function () {
            $scope.deleteBasketItemSelection();
            $scope.handleData();
            $scope.showControl = $scope.controlsLayout !== 1;
        }, function () {
            basketController.addAllAvailableLists($scope.data.basket);
        });
    };

    this.changeAccountAssignmentSupplier = function (aatId, supplierHeader, oldAAT) {
        if (basketController.useBasketControlDialog()) {
            basketController.openSupplierHeaderControlDialog(null, aatId, supplierHeader).then(angular.noop, function () {
                supplierHeader.aat.selected = oldAAT;
            });
        }
        else {
            basketController.changeSupplierAAT(aatId, supplierHeader.id);
        }
    };

    this.changeSupplierAAT = function (aatId, suppHeaderId) {
        lastSelectedSupplierHeaders = [];
        lastSelectedSupplierHeaders.push(suppHeaderId);
        basketController.removeAvailableLists($scope.data.basket);
        var dataObj = {
            basket: $scope.data.basket,
            suppHeaderId: suppHeaderId,
            itemId: 0,
            aatId: aatId
        };
        return dataGen.postAsForm($scope, dataObj, "/basket/changeaat").then(function () {
            $scope.deleteBasketItemSelection();
            $scope.handleData();
            $scope.selectLastSelected();
            $scope.showSupplierControl.value = $scope.controlsLayout !== 1;
            $timeout(function () {
                var target = angular.element('#main-content');
                var topOffset = angular.element('#basketSupplierHeader' + suppHeaderId).offset().top + target.scrollTop();
                target.scrollTop(topOffset - target.offset().top - 20);
            });
        }, function () {
            basketController.addAllAvailableLists($scope.data.basket);
        });
    };

    this.changeAccountAssignmentItem = function (aatId, item, oldAAT) {
        if (basketController.useBasketControlDialog()) {
            basketController.openItemControlDialog(null, aatId, item).then(angular.noop, function () {
                item.aat.selected = oldAAT;
            });
        }
        else {
            basketController.changeItemAAT(aatId, item.id);
        }
    };

    this.changeItemAAT = function (aatId, itemId) {
        lastSelectedItems = [];
        lastSelectedItems.push(itemId);
        basketController.removeAvailableLists($scope.data.basket);
        var dataObj = {
            basket: $scope.data.basket,
            suppHeaderId: 0,
            itemId: itemId,
            aatId: aatId
        };
        return dataGen.postAsForm($scope, dataObj, "/basket/changeaat").then(function () {
            $scope.deleteBasketItemSelection();
            $scope.handleData();
            $scope.selectLastSelected();
            $scope.showItemControl.value = $scope.controlsLayout !== 1;
            $timeout(function () {
                var target = angular.element('#main-content');
                var topOffset = angular.element('#basketItemWrapper' + itemId).offset().top + target.scrollTop();
                target.scrollTop(topOffset - target.offset().top - 20);
            });
        }, function () {
            basketController.addAllAvailableLists($scope.data.basket);
        });
    };

    this.checkAATSelected = function () {
        return impactX.isDefined($scope, 'data.basket.aat.selected.id')
    };

    this.checkRequireAAT = function () {
        if (this.checkIgnoreAccountingRequired()) {
            return false;
        }
        var result = impactX.isDefined($scope, 'data.basket.aat.showMust');
        if (result) {
            var allSuppliersSet = true;
            for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) { // check the supplier headers
                var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
                var supplierSelected = impactX.isDefined(basketSupplier, 'aat.selected.id');
                if (!supplierSelected) { // if the supplier header is not selected...
                    var itemsSelected = true;
                    for (var j = 0; j < basketSupplier.basketItemList.length; j++) { // check the items
                        var item = basketSupplier.basketItemList[j];
                        itemsSelected = itemsSelected && impactX.isDefined(item, 'aat.selected.id');
                    }
                    supplierSelected = itemsSelected;
                }
                allSuppliersSet = allSuppliersSet && supplierSelected;
            }
            result = result && !allSuppliersSet;
        }
        return result;
    };

    this.checkCtrlSelectedHeader = function (ctrlString) {
        return checkCtrlSelected(ctrlString, $scope.data.basket);
    };

    var checkCtrlSelected = function (ctrlString, control) {
        return !!impactX.isDefined(control, 'control.' + ctrlString + '.set.length');
    };

    var checkItemControlsSelected = function (ctrlString, basketSupplier, headerAAT) {
        var itemsSet = true;
        var bksAAT = impactX.isDefined(basketSupplier, 'aat.selected.id');
        for (var j = 0; j < basketSupplier.basketItemList.length; j++) { // check the items
            var item = basketSupplier.basketItemList[j];
            if (item.itemType === 0) {
                var itemAAT = impactX.isDefined(item, 'aat.selected.id');
                if (!itemAAT || itemAAT === bksAAT || (!bksAAT && itemAAT === headerAAT)) {
                    itemsSet = itemsSet && checkCtrlSelected(ctrlString, item);
                }
            }
        }
        return itemsSet;
    };

    this.checkRequireCtrl = function (ctrlString) {
        if (basketController.checkIgnoreAccountingRequired()) {
            $scope.ctrlRequired[ctrlString] = false;
        }
        else {
            var result = impactX.isDefined($scope, 'data.basket.control.' + ctrlString + '.showMust');
            if (result) {
                var allSuppliersSet = true;
                for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) { // check the supplier headers
                    var basketSupplier = $scope.data.basket.basketSupplierHeaderList[i];
                    var bksAAT = impactX.isDefined(basketSupplier, 'aat.selected.id');
                    var supplierIsSet = true;
                    var bkhAAT = basketController.checkAATSelected();
                    if (!bksAAT || bksAAT === bkhAAT) {
                        supplierIsSet = checkCtrlSelected(ctrlString, basketSupplier);
                    }
                    if (!supplierIsSet) { // if the supplier header is not selected...
                        supplierIsSet = checkItemControlsSelected(ctrlString, basketSupplier, bkhAAT);
                    }
                    allSuppliersSet = allSuppliersSet && supplierIsSet;
                }
                result = result && !allSuppliersSet;
            }
            $scope.ctrlRequired[ctrlString] = result;
            if (result) {
                presetCtrlIfSingleSelection(impactX.isDefined($scope, 'data.basket.control.' + ctrlString))
            }
            return result;
        }
    };

    this.checkRequireCtrlSupplier = function (ctrlString, basketSupplier) {
        if (basketController.checkIgnoreAccountingRequired()) {
            return false;
        }
        var showMust = impactX.isDefined(basketSupplier, 'control.' + ctrlString + '.showMust');
        var bkhAAT = basketController.checkAATSelected();
        var bksAAT = impactX.isDefined(basketSupplier, 'aat.selected.id');
        var headerSelected = false;
        // if((bkhAAT && bksAAT && bkhAAT === bksAAT) || (!bkhAAT && !bksAAT) || (bkhAAT && !bksAAT))
        if (!((!bkhAAT && bksAAT) || (bkhAAT && bksAAT && bkhAAT !== bksAAT))) {
            headerSelected = basketController.checkCtrlSelectedHeader(ctrlString);
        }
        var result = showMust && !headerSelected && !checkItemControlsSelected(ctrlString, basketSupplier, bkhAAT);
        if (result) {
            presetCtrlIfSingleSelection(impactX.isDefined(basketSupplier, 'control.' + ctrlString))
        }
        return result;
    };

    this.checkRequireCtrlItem = function (ctrlString, basketItem, basketSupplier) {
        if (basketController.checkIgnoreAccountingRequired()) {
            return false;
        }
        var showMust = impactX.isDefined(basketItem, 'control.' + ctrlString + '.showMust');
        var bkiAAT = impactX.isDefined(basketItem, 'aat.selected.id');
        var bksAAT = impactX.isDefined(basketSupplier, 'aat.selected.id');
        var bkhAAT = basketController.checkAATSelected();
        var supplierSelected = checkCtrlSelected(ctrlString, basketSupplier);
        var headerSelected = basketController.checkCtrlSelectedHeader(ctrlString);
        var result = showMust;
        var depth = aatCheckDepth(bkiAAT, bksAAT, bkhAAT);
        if (depth > 0) {
            result = result && !supplierSelected;
        }
        if (depth > 1) {
            result = result && !headerSelected;
        }
        if (result) {
            presetCtrlIfSingleSelection(impactX.isDefined(basketItem, 'control.' + ctrlString))
        }
        return result;
    };

    var aatCheckDepth = function (bkiAAT, bksAAT, bkhAAT) {
        var depth = 0;
        if (!bkiAAT) {
            if (!bksAAT || bksAAT === bkhAAT) {
                depth = 2; // AA0 or X00
            }
            else {
                depth = 1; // BA0 or 0A0
            }
        }
        else if (!bksAAT) {
            if (bkiAAT === bkhAAT) {
                depth = 2; // A0A
            } // B0A or 00A
        }
        else if (bkiAAT === bksAAT) {
            if (bksAAT === bkhAAT) {
                depth = 2; // AAA
            }
            else {
                depth = 1; // BAA or 0AA
            }
        }
        return depth; // XBA
    };

    var presetCtrlIfSingleSelection = function (control) {
        if ($scope.data.preselectUniqueControls &&
            impactX.isDefined(control, 'set.length') === 0 &&
            impactX.isDefined(control, 'allowed.entries.length') === 1) {
            var tmp = [];
            tmp.push(control.allowed.entries[0]);
            tmp[0].factor = 1;
            control.set = tmp;
        }
    };

    this.showControl = function (ctrl, type) {
        return ctrl && ($scope.showControl || $scope.ctrlRequired[type] || (ctrl.set && ctrl.set.length > 0) || $scope.data.basket.showBasketHeaderAccounts);
    };

    this.checkIgnoreAccountingRequired = function () {
        return $scope.data.basket.ignoreAccountingRequired && checkIgnoreRequired();
    };

    this.checkIgnoreMatGroupRequired = function () {
        return $scope.data.basket.ignoreMaterialGroupRequired && checkIgnoreRequired();
    };

    var checkIgnoreRequired = function () {
        var approval = $scope.data.basket.approval;
        return !approval || (!approval.isAutomaticApproval && !approval.isSelfApproval);
    };

    this.toggleHeaderComments = function () {
        $scope.showComments = !$scope.showComments;
        var otherShown = $scope.showControl || $scope.showDates;
        $scope.showControl = false;
        $scope.showDates = false;
        $scope.showReferenceNos = false;
        $scope.showShare = false;
        $timeout(function () {
            $timeout(function () {
                var target = angular.element('#main-content');
                var topOffset = angular.element('#header-comment-anchor').offset().top + target.scrollTop();
                target.animate({
                    scrollTop: topOffset - target.offset().top
                }, 350);
            }, otherShown ? 500 : 0);
        });
    };

    this.toggleHeaderControl = function () {
        $scope.showControl = !$scope.showControl;
        $scope.showComments = false;
        $scope.showDates = false;
        $scope.showReferenceNos = false;
        $scope.showShare = false;
        $timeout(function () {
            var target = angular.element('#main-content');
            var topOffset = angular.element('#header-control-anchor').offset().top + target.scrollTop();
            target.animate({
                scrollTop: topOffset - target.offset().top
            }, 350);
        });
    };

    this.toggleHeaderDates = function () {
        $scope.showDates = !$scope.showDates;
        $scope.showComments = false;
        $scope.showControl = false;
        $scope.showReferenceNos = false;
        $scope.showShare = false;
        $timeout(function () {
            var target = angular.element('#main-content');
            var topOffset = angular.element('#header-date-anchor').offset().top + target.scrollTop();
            target.animate({
                scrollTop: topOffset - target.offset().top
            }, 350);
        });
    };

    this.toggleHeaderReferenceNos = function () {
        $scope.showReferenceNos = !$scope.showReferenceNos;
        $scope.showDates = false;
        $scope.showComments = false;
        $scope.showControl = false;
        $scope.showShare = false;
    };

    this.toggleHeaderShare = function () {
        $scope.showShare = !$scope.showShare;
        $scope.showReferenceNos = false;
        $scope.showDates = false;
        $scope.showComments = false;
        $scope.showControl = false;
    };

    this.toggleSupplierAddresses = function () {
        $scope.showSupplierAddresses.value = !$scope.showSupplierAddresses.value;
        $scope.showSupplierControl.value = false;
        $scope.showSupplierDate.value = false;
        $scope.showSupplierShare.value = false;
        $scope.showSupplierComments.value = false;
        if ($scope.selectedBasketSupplier && $scope.selectedBasketSupplier.length > 0) {
            $timeout(function () {
                var target = angular.element('#main-content');
                var topOffset = angular.element('#supplier-address-anchor' + $scope.selectedBasketSupplier[0].id).offset().top + target.scrollTop();
                target.animate({
                    scrollTop: topOffset - target.offset().top
                }, 350);
            });
        }
    };

    this.toggleSupplierControl = function () {
        $scope.showSupplierControl.value = !$scope.showSupplierControl.value;
        $scope.showSupplierDate.value = false;
        $scope.showSupplierAddresses.value = false;
        $scope.showSupplierComments.value = false;
        $scope.showSupplierShare.value = false;
        if ($scope.selectedBasketSupplier && $scope.selectedBasketSupplier.length > 0) {
            $timeout(function () {
                var target = angular.element('#main-content');
                var topOffset = angular.element('#supplier-control-anchor' + $scope.selectedBasketSupplier[0].id).offset().top + target.scrollTop();
                target.animate({
                    scrollTop: topOffset - target.offset().top
                }, 350);
            });
        }
    };

    this.toggleSupplierDate = function () {
        $scope.showSupplierDate.value = !$scope.showSupplierDate.value;
        $scope.showSupplierControl.value = false;
        $scope.showSupplierAddresses.value = false;
        $scope.showSupplierComments.value = false;
        $scope.showSupplierShare.value = false;
        if ($scope.selectedBasketSupplier && $scope.selectedBasketSupplier.length > 0) {
            $timeout(function () {
                var target = angular.element('#main-content');
                var topOffset = angular.element('#supplier-date-anchor' + $scope.selectedBasketSupplier[0].id).offset().top + target.scrollTop();
                target.animate({
                    scrollTop: topOffset - target.offset().top
                }, 350);
            });
        }
    };

    this.toggleSupplierComments = function () {
        $scope.showSupplierComments.value = !$scope.showSupplierComments.value;
        var otherShown = $scope.showSupplierControl.value || $scope.showSupplierDate.value || $scope.showSupplierAddresses.value;
        $scope.showSupplierControl.value = false;
        $scope.showSupplierDate.value = false;
        $scope.showSupplierAddresses.value = false;
        $scope.showSupplierShare.value = false;
        if ($scope.selectedBasketSupplier && $scope.selectedBasketSupplier.length > 0) {
            $timeout(function () {
                $timeout(function () {
                    var target = angular.element('#main-content');
                    var topOffset = angular.element('#supplier-comment-anchor' + $scope.selectedBasketSupplier[0].id).offset().top + target.scrollTop();
                    target.animate({
                        scrollTop: topOffset - target.offset().top
                    }, 350);
                }, otherShown ? 500 : 0);
            });
        }
    };

    this.toggleSupplierShare = function () {
        $scope.showSupplierShare.value = !$scope.showSupplierShare.value;
        $scope.showSupplierControl.value = false;
        $scope.showSupplierAddresses.value = false;
        $scope.showSupplierComments.value = false;
        $scope.showSupplierDate.value = false;
        if ($scope.selectedBasketSupplier && $scope.selectedBasketSupplier.length > 0) {
            $timeout(function () {
                var target = angular.element('#main-content');
                var topOffset = angular.element('#supplier-date-anchor' + $scope.selectedBasketSupplier[0].id).offset().top + target.scrollTop();
                target.animate({
                    scrollTop: topOffset - target.offset().top
                }, 350);
            });
        }
    };

    this.toggleItemControl = function () {
        $scope.showItemControl.value = !$scope.showItemControl.value;
        $scope.showItemAddresses.value = false;
        $scope.showItemComments.value = false;
    };

    this.hasReadOnlyHeaderControls = function(aat, controls) {
        if (aat && !aat.readOnly) {
            return false;
        }
        for (var key in controls) {
            if (impactX.isObject(controls[key]) && !controls[key].readOnly) {
                return false;
            }
        }
        return true;
    }

    $scope.initControlWatch = function () {
        for (var key in $scope.data.basket.control) {
            if(impactX.isObject($scope.data.basket.control[key])) {
                const watchedControl = "data.basket.control['" + key + "'].set";
                const labelKey = key;
                $scope.$watchCollection(watchedControl, function (newVal) {
                    if(newVal && newVal.length > 0) {
                        $scope.hasControlLabels[labelKey] = " (" + $scope.trns.parentHasControl + ")";
                    }
                    else {
                        $scope.hasControlLabels[labelKey] = undefined;
                    }
                });
            }
        }
        // Array
        for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
            $scope.supplierControlLabels.push({});
        }
    }

    this.openHeaderControlDialog = function (event, newAATId) {
        var headerControls = $scope.data.basket.control;
        return basketController.openControlStructureDialog(event, headerControls, null, null, newAATId).then(function (data) {
            basketController.changeHeaderAAT(impactX.isDefined(data, 'aat.selected.id')).then(function () {
                $scope.data.basket.aat = data.aat;
                $scope.data.basket.control = data.controls;
                $scope.saveBasketBackground();
            });
        });
    };

    this.removeHeaderControls = function () {
        var controls = $scope.data.basket.control;
        for (var key in controls) {
            if (controls.hasOwnProperty(key) && !controls[key].readOnly) {
                controls[key].set = [];
            }
        }
        if ($scope.data.basket.aat && !$scope.data.basket.aat.readOnly) {
            $scope.data.basket.aat.selected = $scope.data.basket.aat.entries[0];
        }
        $scope.saveBasketBackground();
    };

    this.openSupplierHeaderControlDialog = function (event, newAATId, basketSupplierHeader) {
        var supplierHeader = $scope.selectedBasketSupplier[0] || basketSupplierHeader;
        var supplierHeaderControls = supplierHeader.control;
        return basketController.openControlStructureDialog(event, supplierHeaderControls, supplierHeader, null, newAATId).then(function (data) {
            basketController.changeSupplierAAT(impactX.isDefined(data, 'aat.selected.id'), supplierHeader.id).then(function () {
                $scope.selectedBasketSupplier[0].aat = data.aat;
                $scope.selectedBasketSupplier[0].control = data.controls;
                $scope.saveBasketBackground();
            });
        });
    };

    this.removeSupplierHeaderControls = function (bks) {
        var controls = bks.control;
        for (var key in controls) {
            if (controls.hasOwnProperty(key) && !controls[key].readOnly) {
                controls[key].set = [];
            }
        }
        if (!bks.aat.readOnly) {
            bks.aat.selected = bks.aat.entries[0];
        }
        $scope.saveBasketBackground();
    };

    this.openItemControlDialog = function (event, newAATId, item) {
        var selectedBasketItem = $scope.selectedBasketItems[0] || item;
        var itemAAT = selectedBasketItem.aat;
        var itemControls = selectedBasketItem.control;
        return basketController.openControlStructureDialog(event, itemControls, null, selectedBasketItem, newAATId).then(function (data) {
            basketController.changeItemAAT(impactX.isDefined(data, 'aat.selected.id'), selectedBasketItem.id).then(function () {
                $scope.selectedBasketItems[0].aat = data.aat;
                $scope.selectedBasketItems[0].control = data.controls;
                $scope.saveBasketBackground();
            });
        }, function () {
            $scope.selectedBasketItems[0].aat = itemAAT;
            $scope.selectedBasketItems[0].control = itemControls;
        });
    };

    this.removeItemControls = function (bki) {
        var controls = bki.control;
        for (var key in controls) {
            if (controls.hasOwnProperty(key) && !controls[key].readOnly) {
                controls[key].set = [];
            }
        }
        if (!bki.aat.readOnly) {
            bki.aat.selected = bki.aat.entries[0];
        }
        $scope.saveBasketBackground();
    };

    this.openControlStructureDialog = function (event, controls, bks, bki, aatId) {
        var controlLabels = {};
        if (bks || bki) {
            for (var key in $scope.hasControlLabels) {
                controlLabels[key] = $scope.hasControlLabels[key];
            }
        }
        if (bki) {
            for(var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
                if($scope.data.basket.basketSupplierHeaderList[i].basketItemList.includes(bki)) {
                    for (var key in $scope.supplierControlLabels[i]) {
                        controlLabels[key] = controlLabels[key] || $scope.supplierControlLabels[i][key];
                    }
                    break;
                }
            }
        }
        return BasketService.openBasketControlStructureDialog(event,
            $scope.trns,
            bks,
            bki,
            controls,
            basketController.showControl,
            $scope.saveBasketBackground,
            $scope.data.preselectUniqueControls,
            aatId,
            controlLabels);
    };

    function removeAddresses(addressHolder) {
        if (addressHolder) {
            if (addressHolder.handOverAddresses && !addressHolder.handOverAddresses.readOnly) {
                addressHolder.handOverAddresses = null;
            }
            if (addressHolder.deliveryAddresses && !addressHolder.deliveryAddresses.readOnly) {
                addressHolder.deliveryAddresses = null;
            }
            if (addressHolder.invoiceAddresses && !addressHolder.invoiceAddresses.readOnly) {
                addressHolder.invoiceAddresses = null;
            }
            if (addressHolder.contactAddresses && !addressHolder.contactAddresses.readOnly) {
                addressHolder.contactAddresses = null;
            }
            $scope.saveInProgress = true;
            $scope.saveBasketBackground().finally(function() {$scope.saveInProgress = false;});
        }
    }

    this.openHeaderAddressDialog = function (event) {
        var deliveryAddress = $scope.data.basket.deliveryAddresses;
        var handOverAddresses = $scope.data.basket.handOverAddresses;
        var invoiceAddresses = $scope.data.basket.invoiceAddresses;
        var contactAddresses = $scope.data.basket.contactAddresses;
        basketController.openAddressDialog(event,
            handOverAddresses,
            deliveryAddress,
            invoiceAddresses,
            contactAddresses)
            .then(function (newAddresses) {
                $scope.data.basket.handOverAddresses = newAddresses.handOverAddresses;
                $scope.data.basket.deliveryAddresses = newAddresses.deliveryAddresses;
                $scope.data.basket.invoiceAddresses = newAddresses.invoiceAddresses;
                $scope.data.basket.contactAddresses = newAddresses.contactAddresses;
                $scope.saveInProgress = true;
                $scope.saveBasketBackground().finally(function() {$scope.saveInProgress = false;});
            })
    };

    this.removeHeaderAddresses = function (event) {
        removeAddresses($scope.data.basket);
    };

    this.openSupplierHeaderAddressConflictDialog = function (event, bksId, title) {
        var bks = null;
        for (var i = 0; i < $scope.data.basket.basketSupplierHeaderList.length; i++) {
            if ($scope.data.basket.basketSupplierHeaderList[i].id === bksId) {
                bks = $scope.data.basket.basketSupplierHeaderList[i];
                break;
            }
        }
        basketController.openSupplierHeaderAddressDialog(event, bks, title)
    };

    this.openSupplierHeaderAddressDialog = function (event, bks, title) {
        var supplierHeader = bks ? bks : $scope.selectedBasketSupplier[0];
        if (supplierHeader) {
            var deliveryAddress = supplierHeader.deliveryAddresses;
            var handOverAddresses = supplierHeader.handOverAddresses;
            var invoiceAddresses = supplierHeader.invoiceAddresses;
            var contactAddresses = supplierHeader.contactAddresses;
            basketController.openAddressDialog(event,
                handOverAddresses,
                deliveryAddress,
                invoiceAddresses,
                contactAddresses,
                supplierHeader.id,
                0, title, supplierHeader.regionCode)
                .then(function (newAddresses) {
                    supplierHeader.handOverAddresses = newAddresses.handOverAddresses;
                    supplierHeader.deliveryAddresses = newAddresses.deliveryAddresses;
                    supplierHeader.invoiceAddresses = newAddresses.invoiceAddresses;
                    supplierHeader.contactAddresses = newAddresses.contactAddresses;
                    $scope.saveInProgress = true;
                    $scope.saveBasketBackground().finally(function() {$scope.saveInProgress = false;});
                })
        }
    };

    this.removeSupplierHeaderAddresses = function (bks) {
        removeAddresses(bks);
    };

    this.openItemAddressDialog = function (event, bki) {
        var selectedBasketItem = bki ? bki : $scope.selectedBasketItems[0];
        if (selectedBasketItem) {
            var deliveryAddress = selectedBasketItem.deliveryAddresses;
            var handOverAddresses = selectedBasketItem.handOverAddresses;
            var invoiceAddresses = selectedBasketItem.invoiceAddresses;
            var contactAddresses = selectedBasketItem.contactAddresses;
            basketController.openAddressDialog(event,
                handOverAddresses,
                deliveryAddress,
                invoiceAddresses,
                contactAddresses,
                0, selectedBasketItem.id, undefined, selectedBasketItem.regionCode).then(function (newAddresses) {
                selectedBasketItem.handOverAddresses = newAddresses.handOverAddresses;
                selectedBasketItem.deliveryAddresses = newAddresses.deliveryAddresses;
                selectedBasketItem.invoiceAddresses = newAddresses.invoiceAddresses;
                selectedBasketItem.contactAddresses = newAddresses.contactAddresses;
                $scope.saveInProgress = true;
                $scope.saveBasketBackground().finally(function() {$scope.saveInProgress = false;});
            })
        }
    };

    this.removeItemAddresses = function (bki) {
        removeAddresses(bki);
    };

    this.openAddressDialog = function (event, handOverAddresses, deliveryAddresses, invoiceAddresses, contactAddresses, bksId, bkiId, title, regionCodeDeliveryAddress) {
        var addresses = {
            handOverAddresses: handOverAddresses,
            deliveryAddresses: deliveryAddresses,
            invoiceAddresses: invoiceAddresses,
            contactAddresses: contactAddresses,
        };
        return BasketService.openBasketAddressDialog(event,
            $scope.trns,
            addresses,
            bksId, bkiId, title, regionCodeDeliveryAddress);
    };

    this.toggleItemAddress = function () {
        $scope.showItemAddresses.value = !$scope.showItemAddresses.value;
        $scope.showItemControl.value = false;
        $scope.showItemComments.value = false;
    };

    this.toggleItemComments = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
        $scope.showItemControl.value = false;
        $scope.showItemAddresses.value = false;
    };

    this.addToCurrentBasket = function () {
        dataGen.post($scope, {selected: [{id: $scope.data.basket.id}]}, "/basket/addtocurrentbasket").then(function (data) {
            $context.refreshBasket({}, dataGen, $context);
            $location.path("/basket");
            $mdToast.show(
                $mdToast.simple()
                    .textContent(TranslationService.get("addSuccess"))
                    .position("bottom right")
                    .hideDelay(10000)
            );
        }, function () {
            $context.refreshBasket({}, dataGen, $context);
        });
    };
    this.addItemsToCurrentBasket = function () {
        dataGen.postAsForm({}, {
            templateBKHId: $scope.data.basket.id,
            toAdd: $scope.selectedBasketItems
        }, "/basket/items/addfromtemplate").then(function (data) {
            $context.refreshBasket({}, dataGen, $context);
            $location.path("/basket");
            $mdToast.show(
                $mdToast.simple()
                    .textContent(TranslationService.get("addSuccess"))
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.replaceItem = function () {
        var bkiId = $scope.selectedBasketItems[0].id;
        var paramObject = {
            oldBKIId: bkiId,
            actionTrns: $scope.trns.saveSuccess
        };

        var config = {
            title: $scope.trns.replaceItem
        };
        ProductSelectionService.open(config).then(function (selectedProduct) {
            if (selectedProduct) {
                AddToBasketService.replaceInBasketParamObject(selectedProduct, paramObject).then($route.reload);
            }
        });
    };

    this.duplicateItem = function () {
        var bkiId = $scope.selectedBasketItems[0].id;
        var dataObject = {
            bkiId: bkiId
        };
        $scope.saveBasketBackground().then(function () {
            dataGen.postAsForm({}, dataObject, '/basket/freeformitem/copy').then(function (data) {
                $context.refreshBasket({}, dataGen, $context);
                $scope.deleteBasketItemSelection();
                $scope.getBasket();
                ToastService.openStandardToast(data.trns.saveSuccess);
            });
        });
    };

    this.validateOCIItem = function () {
        var bkiId = $scope.selectedBasketItems[0].id;
        dataGen.getData({}, {bkiId: bkiId, impactX: true}, "/oci/validateitem").then(function (data) {
            if (data.data.url) {
                window.location.href = data.data.url;
            }
            else {
                document.getElementsByTagName("body")[0].innerHTML = data.data.form;
                $("form#validateItem").submit();
            }
        });
    };

    this.detailOCIItem = function () {
        var bkiId = $scope.selectedBasketItems[0].id;
        dataGen.getData({}, {bkiId: bkiId, impactX: true}, "/oci/detailitem").then(function (data) {
            if (data.data.detailURL) {
                NewWindowService.openNewWindow(data.data.detailURL, '_blank');
            }
        });
    };

    this.validateSAPBasket = function () {
        var dataObject = {
            basket: $scope.data.basket
        };
        return dataGen.postAsForm({}, dataObject, '/basket/validatesap').then(function (data) {
            if (data.errors.length === 0 && data.data) {
                $scope.data = data.data;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.validateSAPSuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
            }
        });
    };

    $scope.toggleDitributionListFlag = function (onInit) {
        if ($scope.data.basket.sendDistributionList) {
            const itemErrors = [];
            if($scope.data.basket.sendDistributionList.value) {
                angular.forEach($scope.data.basket.basketSupplierHeaderList, function (bks) {
                    if(!bks.allowDistributionList) {
                        return;
                    }
                    angular.forEach(bks.basketItemList, function (bki) {
                        if(!bki.allowDistributionList && bki.itemType === 0) {
                            itemErrors.push({error: $scope.trns.distributionListNotAllowed.replace("^0", bki.name.value).replace("^1", bks.contractName + " (" + bks.contractNo + ")")});
                        }
                    });
                });
                if(itemErrors.length > 0) {
                    // Deactivate and show errors
                    $scope.data.basket.sendDistributionList.value = false;
                    $errorHandler.showErrors(itemErrors, null, null, false, [])
                    if(!onInit) {
                        return;
                    }
                }
            }
            angular.forEach($scope.data.basket.basketSupplierHeaderList, function (bks) {
                if($scope.data.basket.sendDistributionList.value) {
                    if (bks.firstDeliveryDate && !bks.firstDeliveryDate.readOnly) {
                        bks.firstDeliveryDate.dateValue = null;
                        bks.firstDeliveryDate.value = null;
                    }
                    if (bks.lastDeliveryDate && !bks.lastDeliveryDate.readOnly) {
                        bks.lastDeliveryDate.dateValue = null;
                        bks.lastDeliveryDate.value = null;
                    }
                }
                angular.forEach(bks.basketItemList, function (bki) {
                    if (bki.sendDistributionList && bki.itemType === 0) {
                        bki.sendDistributionList.value = $scope.data.basket.sendDistributionList.value;
                        if(bki.sendDistributionList.value) {
                            removeDates(bki, true);
                        }
                    }
                });
            });
        }
        if(!onInit) {
            $scope.basketHasChanged = true;
        }
    };

    var openDateDialog = function (event, dateHolder, title, sendDistributionList) {
        BasketService.openDatesDialog(event, $scope.trns,
            dateHolder.deliveryDate,
            dateHolder.firstDeliveryDate,
            dateHolder.lastDeliveryDate,
            title,
            $scope.minDate, sendDistributionList)
            .then(function (result) {
                dateHolder.deliveryDate = result.date;
                dateHolder.firstDeliveryDate = result.firstDate;
                dateHolder.lastDeliveryDate = result.lastDate;
                $scope.saveBasketBackground();
            });
    };

    var removeDates = function (dateHolder, noSave) {
        if (dateHolder.deliveryDate && !dateHolder.deliveryDate.readOnly) {
            dateHolder.deliveryDate.dateValue = null;
            dateHolder.deliveryDate.value = null;
        }
        if (dateHolder.firstDeliveryDate && !dateHolder.firstDeliveryDate.readOnly) {
            dateHolder.firstDeliveryDate.dateValue = null;
            dateHolder.firstDeliveryDate.value = null;
        }
        if (dateHolder.lastDeliveryDate && !dateHolder.lastDeliveryDate.readOnly) {
            dateHolder.lastDeliveryDate.dateValue = null;
            dateHolder.lastDeliveryDate.value = null;
        }
        if(noSave) {
            return;
        }
        $scope.saveBasketBackground();
    };

    this.openHeaderDatesDialog = function (event) {
        openDateDialog(event, $scope.data.basket, $scope.trns.dates)
    };

    this.removeHeaderDates = function () {
        removeDates($scope.data.basket);
    };

    this.openSupplierHeaderDatesDialog = function (event, bks) {
        var dateHolder = bks ? bks : $scope.selectedBasketSupplier[0];
        if (dateHolder) {
            const sendDistributionList = dateHolder.allowDistributionList && $scope.data.basket.sendDistributionList && $scope.data.basket.sendDistributionList.value;
            if(dateHolder.supplierRequestedDeliveryDatesAvailable) {
                BasketService.openRequestedDatesDialog(event, $scope.trns, dateHolder, $scope.trns.datesForBKS, bks ? bks.id : $scope.selectedBasketSupplier[0].id, sendDistributionList);
            }
            else {
                openDateDialog(event, dateHolder, $scope.trns.datesForBKS, sendDistributionList)
            }
        }
    };

    this.removeSupplierHeaderDates = function (bks) {
        var dateHolder = bks ? bks : $scope.selectedBasketSupplier[0];
        if (dateHolder) {
            removeDates(dateHolder);
        }
    };

    this.openItemDatesDialog = function (event, bki) {
        var dateHolder = bki ? bki : $scope.selectedBasketItems[0];
        if (dateHolder) {
            openDateDialog(event, dateHolder, $scope.trns.datesForBKI);
        }
    };

    this.removeItemDates = function (bki) {
        var dateHolder = bki ? bki : $scope.selectedBasketItems[0];
        if (dateHolder) {
            removeDates(dateHolder);
        }
    };

    this.changeBuyerCompanyWithBasket = function (comId) {
        if (comId > 0 && $scope.selectedComId !== comId) {
            $scope.saveBasketBackground().then(function () {
                dataGen.postAsForm({}, {comId: comId}, '/authorization/changebuyercompanywithbasket').then(function () {
                    $route.reload();
                });
            });
        }
    };

    $scope.changePayerCompany = function (basketItem) {
        if (basketItem) {
            $scope.saveBasketBackground().then(function () {
                var dataObj = {
                    bkiId: basketItem.id,
                    payerComId: basketItem.payerCompany.selected.id
                };
                dataGen.postAsForm({}, dataObj, '/basket/changePayerCompany').then(function () {
                    $route.reload();
                });
            });
        }
    };

    $scope.prgSelected = function (basketItem, selected) {
        $scope.saveBasketBackground().then(function () {
            var dataObj = {
                bkiId: basketItem.id,
                prgId: selected.id
            };
            dataGen.postAsForm({}, dataObj, '/basket/item/prg/change').then(function () {
                $route.reload();
            });
        });
    };

    $scope.$watchCollection('errorListForSend', function() {
        $scope.errorListSendAndProcess.length = 0;
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListForSend);
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListProcess);
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListForDirty);
    });

    $scope.$watchCollection('errorListProcess', function() {
        $scope.errorListSendAndProcess.length = 0;
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListForSend);
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListProcess);
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListForDirty);

    });

    $scope.$watchCollection('errorListForDirty', function() {
        $scope.errorListSendAndProcess.length = 0;
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListForSend);
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListProcess);
        $scope.errorListSendAndProcess = $scope.errorListSendAndProcess.concat($scope.errorListForDirty);

    });

    this.addStatusEmailAddress = function (emailValue) {
        LoadingDialogService.start();
        var dataObj = {
            id: $scope.data.basket.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/basket/statusmailaddress/header/add').then(function () {
            LoadingDialogService.stop();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        },
        function () {
            LoadingDialogService.stop();
            $scope.data.basket.statusEMailAddresses.pop();
        });
    }

    this.deleteStatusEmailAddress = function (emailValue) {
        LoadingDialogService.start();
        var dataObj = {
            id: $scope.data.basket.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/basket/statusmailaddress/header/delete').then(function () {
            LoadingDialogService.stop();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        },
        function () {
            LoadingDialogService.stop();
            $scope.data.basket.statusEMailAddresses.push(emailValue);
        });
    };
    
    $scope.printVisitingCard = function () {
          
          dataGen.post($scope, {bkiId:  $scope.selectedBasketItems[0].id}, '/basket/visitingcard/item/preview', null, {responseType: 'arraybuffer'}).then(function (data) {
                  var fileName = getFileNameFromResponseHeaders(dataGen.lastRequestHeaders());
                  if (window.navigator.msSaveOrOpenBlob) {
                      window.navigator.msSaveOrOpenBlob(new Blob([data], {type: 'application/pdf'}), fileName);
                  }
                  else {
                      var file = new Blob([data], {type: 'application/pdf'});
                      $scope.newWindow.location = URL.createObjectURL(file);
                      $scope.newWindow.document.title = fileName;
                  }
              }
          );
      };
    
    function getFileNameFromResponseHeaders(responseHeaders) {
        openNewWindow();
        var fileName = "";
        if (responseHeaders) {
            var contentDisposition = responseHeaders['Content-Disposition'];
            if (contentDisposition) {
                fileName = contentDisposition.split(';')[1].trim().split('=')[1];
            }
        }
        return fileName;
    }
    
    function openNewWindow() {
        if (!window.navigator.msSaveOrOpenBlob) {
            $scope.newWindow = NewWindowService.openNewWindow('')
        }
    }

    /**
     * Prüft, ob an der Anforderung tatsächlich noch eine Genehmigung hängt: ein externer
     * Genehmigungsschritt oder ein Genehmigungsschritt mit Genehmigern. Anders als hasApproval() zählt
     * das reine automatische Genehmigungsverfahren aus der Mandantenkonfiguration NICHT als
     * ausstehende Genehmigung — es ist dort dauerhaft aktiv, auch wenn keine Regel greift.
     * Wird für den Abschlussdialog der Zuschlagsentscheidung gebraucht: nur ohne ausstehende
     * Genehmigung startet die Stillhaltefrist mit dem Absenden des Warenkorbs.
     */
    function hasPendingApproval() {
        var approval = $scope.data.basket.approval;
        if (!approval) {
            return false;
        }
        if (approval.externalApprovalStep) {
            return true;
        }
        return !!(approval.approvalSteps && approval.approvalSteps.filter(function (approvalStep) {
            return approvalStep.setEntries && approvalStep.setEntries.length > 0;
        }).length > 0);
    }

    function handleAWD(event, needsAWD) {
        const defer = $q.defer();
        if (needsAWD) {
            ixaBasketActions.openAwardDecisionBasketCompanyDialog($scope.data.basket.id, hasPendingApproval(), event).then(function (data) {
                if(data && data.sent) {
                    defer.resolve();
                }
                else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            });
        }
        else {
            defer.resolve();
        }
        return defer.promise;
    }

}
